import { ChangeDetectorRef, Component, ElementRef, Inject, InjectFlags, TemplateRef, ViewChild, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NZ_MODAL_DATA } from 'mwc/modal';
import { MwcModalRef, MwcModalService } from 'mwc/modal';
import { SelectPromptsModalComponent } from './select-prompts-modal/select-prompts-modal.component';
import { GetTopicIdeaListRequest, GetTopicIdeaListResponse, topicIdea } from '../_shared/models/topic';
import { TopicIdeaPayloadForAIGeneration, TopicIdeaPayloadForAIGenerationType } from '../_shared/models/TopicIdeaPayloadForAIGeneration';
import { ContentOutlineSection, GenerateContentOutlineResponse } from '../_shared/models/content-outline';
import { ArticleService } from '../services/article/article.service';
import { Content, OpenAIContextResponseType } from '../_shared/models/open-ai';
import { ArticleHelperService } from '../_shared/services/helper/article/article-helper.service';
import { ErrorModalOrigins, FAQ, KeywordConstraint } from '../_shared/consts/article-constants';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Article, BrandVoice, BrandVoiceThingJson, CustomArticleErrorModel, DefaultBrandVoiceForProfileRequest, DefaultTargetAudienceForProfileRequest, DocumentDetail, DocumentLanguage, GetBrandVoiceListRequest, GetBrandVoiceListResponse, GetTargetAudienceListRequest, GetTargetAudienceListResponse, PromptProperties, TargetAudience, GenerateQuestionsByAIRequest, GenerateQuestionsByAIResponse, GetAllTemplateResponse, Template, AddOrRemoveAsFavoriteTemplateRequest, AddOrRemoveAsFavoriteTemplateResponse, ContextAnalysisDetails, ContextAnalysisDetailsResponse, Faq, FaqAnswer, FaqImage, GetAllTemplateRequest, ValidateUrlRequest, AssignedUser, FindAssignedUsersResponse } from '../_shared/models/article';
import { ArticleStoreService } from '../services/article/article-store.service';
import { TopicService } from '../services/topic/topic.service';
import { GetAudiencesRequest } from '../_shared/models/GetAudiencesRequest';
import { StorageHelper } from '../_utilities/storage-helper';
import { GetAudiencesResponseType } from '../_shared/models/GetAudiencesResponse';
import { GoogleKeywordPlannerResponseType } from '../_shared/models/google-keyword-planner';
import { SelectYourKeywordComponent } from '../manage-content/articles/select-your-keyword/select-your-keyword.component';
import { UpdateAudienceRequest } from '../_shared/models/UpdateAudienceRequest';
import { SettingsService } from '../services/settings/settings.service';
import { MwcMessageService } from 'mwc/message';
import { ContentStudioTrackingService, TrackEventProperties } from '../_shared/services/tracking/contentstudio-tracking.service';
import { CmsService } from '../services/cms/cms.service';
import { TemplateHelperService } from '../_shared/services/helper/template-selector/template-helper.service';
import { CommonService } from '../services/common/common.service';
import { FEATURES } from '../_shared/consts/app-constants';
import { UserInfo } from '../_shared/models/common';
import { GetSettingsFileRequest } from '../_shared/models/getsettingsfilerequest';
import { GetSettingsFileResponse } from '../_shared/models/getsettingsfileresponse';
import { NewTemplateHelperService } from 'src/app/_shared/services/helper/new-template-selector/new-template-helper.service';
import { catchError, debounceTime, delay, distinctUntilChanged, filter, finalize, forkJoin, interval, map, Observable, of, Subject, Subscription, switchMap, take, takeUntil, tap } from 'rxjs';
import { MwcUploadChangeParam, MwcUploadFile } from 'mwc/upload';
import { MwcNotificationService } from 'mwc/notification';
import { GenerationInProgressHelperService } from '../_shared/services/helper/generation-in-progress-popup/generation-in-progress-popup-helper.service';
import { AIWaitingInfo } from '../_shared/models/topic';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CampaignData } from '../campaigns/view-campaigns/view-campaigns.component';
import { CampaignService } from '../services/campaign/campaign.service';
import { Goal } from '../_shared/models/campaigns';
import { IntelligentSearchService } from '../services/intelligentSearch/intelligent-search.service';
import { GetTenantIDRequest, GetTenantIDResponse } from '../_shared/models/get-tenant-id-request';
import { AbpService } from '../services/abp/abp.service';
import { GenerativeSearchResponse, HybridSearchRequest, SearchResponse, SemanticSearchRequest, SemanticSearchRequestV2, SearchResponseV2 } from '../_shared/models/intelligentSearch';
import { AgenticGenerationConfig, AgenticGenerationResponse } from '../_shared/models/agentic-generation';


const ageList = [{ label: "All", value: "all" }, { label: 'Children (Below 13)', value: '0-13' }, { label: 'Adolescents (13 to 17)', value: '13-17' }, { label: 'Growing Adults (18 to 24)', value: '18-24' }, { label: 'Young Adults (25-34)', value: '25-34' }, { label: 'Older Adults (35 to 50)', value: '35-50' }, { label: 'Mature Adults (Above 50)', value: '50+' }];

export interface UploadValidationError {
  title: string;
  description: string;
}

@Component({
  selector: 'app-genarate-ai',
  templateUrl: './genarate-ai.component.html',
  styleUrls: ['./genarate-ai.component.scss']
})
export class GenarateAiComponent {

  generateModalAIRef: any;
  agenticGenerationConfig: AgenticGenerationConfig = new AgenticGenerationConfig();
  constructor(private fb: FormBuilder, @Inject('BASE_URL') private baseUrl: string,
    private notification: MwcNotificationService,
    private generationInProgressHelperService: GenerationInProgressHelperService,
    private modalService: MwcModalService, private modal: MwcModalRef, public cdRef: ChangeDetectorRef, private articleService: ArticleService,
    private articleHelperService: ArticleHelperService, private router: Router, private articleStoreService: ArticleStoreService, private topicService: TopicService, private settingsService: SettingsService, private message: MwcMessageService, private tracking: ContentStudioTrackingService
    , private cms: CmsService,
    private templateHelperService: TemplateHelperService,
    private newTemplateHelperService: NewTemplateHelperService,
    private commonService: CommonService,
    private http: HttpClient,
    private _router: Router,
    private intelligentSearchService: IntelligentSearchService,
    private campaignService: CampaignService,
    private abpService: AbpService  ) {
    this._storageHelper = new StorageHelper();
  }

  provinceData = [
    //{ id: 30, label: "Arabic", languageCode: "ar", value: "SA" } Saudi Arabia
    { id: 12, label: "English", languageCode: "en", value: "US" }, // United States
    { id: 199, label: "English(UK)", languageCode: "gb", value: "GB" }, // English(UK)
    { id: 16, label: "French", languageCode: "fr", value: "FR" }, // France
    { id: 15, label: "German", languageCode: "de", value: "DE" }, // Germany
    { id: 11, label: "Hindi", languageCode: "hi", value: "IN" }, // India
    { id: 86, label: "Indonesian", languageCode: "id", value: "ID" }, // Indonesia
    { id: 29, label: "Japanese", languageCode: "ja", value: "JP" }, // Japan
    { id: 18, label: "Korean", languageCode: "ko", value: "KR" }, // South Korea
    { id: 190, label: "Mandarin", languageCode: "zh-CN", value: "CN" }, // China
    { id: 9, label: "Portuguese", languageCode: "pt", value: "PT" }, // Portugal
    //{ id: 26, label: "Portuguese (Mexico)", languageCode: "pt-mx", value: "PT" }, // Brazil
    { id: 8, label: "Russian", languageCode: "ru", value: "RU" }, // Russia
    { id: 17, label: "Spanish", languageCode: "es", value: "ES" }, // Spain
    { id: 32, label: "Spanish (Mexico)", languageCode: "es-mx", value: "MX" }, // Mexico
    { id: 31, label: "Swahili", languageCode: "sw", value: "KE" }, // Kenya
    { id: 170, label: "Turkish", languageCode: "tr", value: "TR" }, // Turkey
    { id: 25, label: "Vietnamese", languageCode: "vi", value: "VN" }, // Vietnam
    //{ id: 63, label: "Chinese", languageCode: "zh", value: "CN" } //Chinese
  ];

  generateAiForm: FormGroup | undefined;
  readonly mwcModalData: { AIData: TopicIdeaPayloadForAIGenerationType, campaignData: CampaignData, topicIdeaData: topicIdea, textTitle: string, isRegenerateFlow:boolean } = inject(NZ_MODAL_DATA, InjectFlags.Optional);

  currentSelectedTopicData: topicIdea = this.mwcModalData.AIData.topicIdea;
  isLoading = false;
  toneTypes: string[] = [];
  selectedValueProjectType = "Blog";
  lang = this.mwcModalData.AIData.language;
  match = (this.lang && this.lang !== 'null')
    ? this.provinceData.find(p =>
        p.id === Number(this.lang) ||
        p.languageCode?.toLowerCase() === String(this.lang).toLowerCase() ||
        p.value?.toLowerCase() === String(this.lang).toLowerCase())
    : null;
  selectedValueLanguage = (!this.lang || this.lang === 'null') ? "US" : (this.match?.value ?? this.lang);
  selectedValueTone = this.mwcModalData.AIData.tone && this.mwcModalData.AIData.tone !== 'null' ? this.mwcModalData.AIData.tone : "Informative";
  selectedValueGender = this.mwcModalData.AIData.gender && this.mwcModalData.AIData.gender !== 'null' ? this.mwcModalData.AIData.gender : "All";
  selectedValueAgeGroup = this.mwcModalData.AIData.ageGroup && this.mwcModalData.AIData.ageGroup !== 'null' ? this.mwcModalData.AIData.ageGroup : "All";
  selectedValueInterestAndPersona = this.mwcModalData.AIData.interestAndPersona && this.mwcModalData.AIData.interestAndPersona !== 'null' ? this.mwcModalData.AIData.interestAndPersona : "All";
  selectedTemplateTitle = this.mwcModalData.AIData.templateTitle;
  selectedTemplateId = this.mwcModalData.AIData.templateId;
  inputText = this.mwcModalData.AIData.inputText;
  titleText = this.mwcModalData.AIData.titleText;
  placeholderText = this.mwcModalData.AIData.placeholderText;
  contentBriefText = this.mwcModalData.AIData.contentBriefText;
  isPublishable = this.mwcModalData.AIData.isPublishable;
  isadvancedSettingsShow = false;
  isContentBriefEnabled = false;
  geoRecommendationId = this.mwcModalData.AIData.geoRecommendationId ? this.mwcModalData.AIData.geoRecommendationId : null;
  _storageHelper: StorageHelper;
  //Selected Keywords
  selectedKeywords = [];
  keywordInputVisible = false;
  selectedKeywordInputValue = '';
  //Selected Prompts
  selectedPrompts: string[] = [];
  promptInputVisible = false;
  selectedPromptInputValue = '';
  maxPromptsAllowed = 2;
  //Set while the suggested prompts for an Article Ideas topic are being fetched on open
  isPromptsPrepopulating = false;
  //Prompts/Keywords tab switcher (Topic Details redesign)
  promptsKeywordsView: 'prompts' | 'keywords' = 'prompts';
  //Prompts: uploading a document is the primary path, manual entry is the fallback
  isPromptTagsVisible = true;
  isPromptUploadVisible = false;
  //Keywords: manual entry is the primary path, uploading a document is the fallback
  isKeywordTagsVisible = true;
  isKeywordUploadVisible = false;
  promptSampleFile: File | null = null;
  keywordSampleFile: File | null = null;
  promptUploadPercent: number | null = null;
  keywordUploadPercent: number | null = null;
  promptUploadError: UploadValidationError | null = null;
  keywordUploadError: UploadValidationError | null = null;
  // Single-column spreadsheet, or a CSV of comma-separated values. A valid CSV can be only a
  // few dozen bytes, so there is no minimum beyond "not empty".
  readonly allowedSampleFileExtensions = ['xlsx', 'xls', 'csv'];
  readonly minSampleFileSize = 1;
  readonly maxSampleFileSize = 5 * 1024 * 1024; // 5MB
  // Topic suggestions come from the profile's own topic ideas. Fetched once into a pool, then each
  // refresh draws three that have not been shown yet.
  readonly topicSuggestionCount = 3;
  readonly topicSuggestionPoolSize = 30;
  topicSuggestionPool: string[] = [];
  shownTopicSuggestions: Set<string> = new Set<string>();
  topicSuggestions: string[] = [];
  isTopicSuggestionsLoading = false;
  //campaignId = this.mwcModalData?.campaignId ? this.mwcModalData.campaignId : "";
  campaignData = this.mwcModalData?.campaignData ? this.mwcModalData.campaignData : null;
  @ViewChild('inputElement', { static: false }) inputElement?: ElementRef;
  @ViewChild('promptInputElement', { static: false }) promptInputElement?: ElementRef;
  toneData = [{ label: 'Informative', value: 'Informative' },
  { label: 'Persuasive', value: 'Persuasive' },
  { label: 'Inspirational', value: 'Inspirational' },
  { label: 'Educational', value: 'Educational' },
  { label: 'Storytelling', value: 'Storytelling' },
  { label: 'Formal', value: 'Formal' },
  { label: 'Conversational', value: 'Conversational' }];

  projectTypeData = [{ label: 'Web Page', value: 'Web Page' },
    { label: 'Newsletter', value: 'Persuasive' },
    { label: 'Blog', value: 'Blog' },
    { label: 'How to Article', value: 'How to Article' },
    { label: 'Listicle', value: 'Listicle' },
    { label: 'Press Release', value: 'Press Release' },
    { label: 'News Article', value: 'News Article' }];

  //provinceData = [{ label: 'English (US)', value: 'US' }, { label: 'English (UK)', value: 'GB' }, { label: 'Spanish', value: 'ES' }, { label: 'French', value: 'FR' }, { label: 'German', value: 'DE' }, { label: 'Portugese', value: 'PT' }];
  genderList = [{ label: 'All', value: 'All' },
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Binary (Male or Female)', value: 'Binary' },
  { label: 'Non-Binary (Neither Male Neither Female)', value: 'Non-Binary' }];
  ageGroupList = [
    { label: "All", value: "All" },
    { label: 'Children (Below 13)', value: 'Children' },
    { label: 'Adolescents (13 to 17)', value: 'Adolescents' },
    { label: 'Growing Adults (18 to 24)', value: 'Growing Adults' },
    { label: 'Young Adults (25-34)', value: 'Young Adults' },
    { label: 'Older Adults (35 to 50)', value: 'Older Adults' },
    { label: 'Mature Adults (Above 50)', value: 'Mature Adults' }];
  interestsPersonalsList = [{ label: "All", value: "All" }];;
  selectedValueAIEngine = "_openAI";
  AIEngine = [
    { label: "Open AI", value: "_openAI" },
    { label: "Google Vertex AI", value: "_googleVertexAI" }
  ];
  goalsList = [
    {
      title: "Informational",
      icon: "user-awareness",
      iconColor: "primary",
      description: "Increase recognition and visibility of your brand among target audiences. This goal ensures your brand stays top-of-mind, builds trust, and creates long-term customer relationships.",
      isSelectedGoal: true
    },
    {
      title: "Navigational",
      icon: "funnel-flow",
      iconColor: "primary",
      description: "Capture potential customers by collecting their information through campaigns. This goal helps build a strong sales pipeline and drive conversions through targeted outreach.",
      isSelectedGoal: false
    },
    {
      title: "Commercial",
      icon: "handshake",
      iconColor: "green",
      description: "Foster meaningful interactions with your audience across channels. Engaged customers are more loyal, provide valuable feedback, and contribute to brand advocacy.",
      isSelectedGoal: false
    },
    {
      title: "Transactional",
      icon: "hand-flag",
      iconColor: "green",
      description: "Establish authority in your industry by sharing expertise and insights. This builds trust, credibility, and attracts customers who see your brand as a knowledgeable leader.",
      isSelectedGoal: false
    },
    //{
    //  title: "Increase Revenue",
    //  icon: "currency-dollar",
    //  iconColor: "yellow",
    //  description: "Drive sales by converting prospects into customers and upselling existing ones. This goal focuses on optimizing marketing efforts to maximize profitability and business growth.",
    //  isSelectedGoal: false
    //},
    //{
    //  title: "SEO Presence",
    //  icon: "seo",
    //  iconColor: "yellow",
    //  description: "Improve search engine rankings to boost organic traffic and visibility. Strong SEO ensures long-term discoverability, leading to increased brand exposure and inbound leads.",
    //  isSelectedGoal: false
    //},
    //{
    //  title: "Customer Nurturing",
    //  icon: "users-01",
    //  iconColor: "violet",
    //  description: "Build long-term relationships by educating and engaging prospects. This goal focuses on guiding leads through the sales funnel and improving retention.",
    //  isSelectedGoal: false
    //},
    //{
    //  title: "Product Highlight",
    //  icon: "cube-01",
    //  iconColor: "violet",
    //  description: "Showcase key features and benefits of your product to attract buyers. This goal emphasizes value proposition, addressing customer needs and driving conversions.",
    //  isSelectedGoal: false
    //}
  ];
  isGenericFlow = this.mwcModalData.AIData.isGenericFlow ? this.mwcModalData.AIData.isGenericFlow : false;
  personaEnabled: boolean = false;
  addedPersona: any;
  isContentIntelligenceEnabled: boolean
  contentBriefPlaceholder =
    `Share a prompt explaining any additional content relevancy you would like your article to reference. Max 100 words.`;
  maxKeywordsAllowed: number = KeywordConstraint.MAX_KEYWORDS;
  retryCount = 0;
  maxRetryCount = 4;
  //contentTextData = { titleText: "", placeholderText: "", contentBriefText: "" };
  isNoCreateBrandVoice: boolean = true;
  brandVoiceList = [];
  filteredBrandVoiceList = [];
  selectedBrandVoice: string;
  @ViewChild('contentTextarea') contentTextarea!: ElementRef<HTMLTextAreaElement>;
  brandVoiceDetails: { label: string, value: string, tone: string, createdOn: string, createdBy: string, brandVoiceDocument: string, details: BrandVoiceThingJson };
  isExpanded = false;


  isNoTargetAudience: boolean = true;
  selectedTargetAudience: string;
  targetAudienceList = [];
  filteredTargetAudienceList = [];
  targetAudienceDetails: TargetAudience;

  isRedirectToMPC = false;
  modalType: string;
  brandVoiceUrl: string;
  targetAudienceUrl: string;
  planType: string = 'lite-users';
  hasKeywordPlanner: boolean = true;
  isSaasUser: boolean = false;
  isDefaultBVAvailable: boolean = false;
  defaultBVId: number = 0;
  isDefaultTAAvailable: boolean = false;
  defaultTAId: number = 0;
  //
  selectedIndex = 0;
  tabs: any = [];
  bvSearchField: FormControl = new FormControl();
  tvSearchField: FormControl = new FormControl();
  questionsFromAI: string[];
  isQuestionExist: boolean = false;
  contentBriefQA: string;
  searchTxt: string = '';
  timeout = null;
  isShowDetailsBV: boolean = false;
  isShowDetailsTA: boolean = false;
  FoundSerchBV: boolean = true;
  FoundSearchTA: boolean = true;
  private clickCount: number;

  //Template
  noTemplateExist: boolean = false;
  rowedData = [];
  allTemplates = [];
  templatesList = [];
  filteredTemplatesList = [];
  templatesForGeneration: Template[] = [];
  showSelectTemplatesTab: boolean = false;
  FoundSearchTemplates: boolean = true;
  templatesSearchField: FormControl = new FormControl();
  searchTxtTemplates: string = '';
  filterBy: string = 'recommended';
  private destroy$: Subject<any> = new Subject();
  AllTemplateResponse: GetAllTemplateResponse;
  templatesCount = {};
  templateTypes = ['web', 'news', 'social', 'media', 'advertising', 'emails'];
  settings: GetSettingsFileResponse;
  viewData: any;
  isViewDetails: boolean = false;
  topicData = this.mwcModalData?.topicIdeaData ? this.mwcModalData.topicIdeaData : null;
  textTitle = this.mwcModalData?.textTitle ? this.mwcModalData.textTitle : "";
  selectedCard;
  //make as input
  hideChangeWorkflow: boolean = this.mwcModalData.AIData.hideChangeWorkflow;
  refreshExistingContent: boolean =
    ["Content Repurpose"].includes(this.mwcModalData.AIData.templateTitle);
  youtubeSummaryContent: boolean =
    ["Youtube Summary"].includes(this.mwcModalData.AIData.templateTitle);
  generateFaqsFromExistingContent: boolean =
    ["FAQs"].includes(this.mwcModalData.AIData.templateTitle);
  customTemplates: boolean =
    ["Landing Page"].includes(this.mwcModalData.AIData.templateTitle);
  bulkMetaGeneration: boolean =
    ["Bulk Meta Generator"].includes(this.mwcModalData.AIData.templateTitle);
  //upload
  fileToUpload: any;
  contentAnalysis: boolean = false;
  contentAnalysisStatus = '';
  isUploadVisible: boolean = true;
  isUrlVisible: boolean = true;
  isAnalyzeandProceed: boolean = false;
  uploadFileSubscription: Subscription;

  //bulk upload 
  bulkUploadAnalysis: boolean = false;
  bulkUploadAnalysisStatus = '';
  isParentUrlVisible: boolean = true;
  isIndividualUrlVisible: boolean = true;
  isRegenerateFlow: boolean = false;
  regenerateFlowButtonText: string = 'Proceed';
  knowledgeVaultVisibility: boolean = false;
  isKnowledgeVaultEnable: boolean = false;
  isInternalLinksEnable: boolean = false;
  KnowledgeVaultChunkData: string = '';
  isSettingsEnableKnowledgeVault: boolean = false;
  contentBriefMaxWords: number = 200;

  //Stepper sidebar (Figma shell redesign)
  stepSubtitles: { [key: string]: string } = {
    'Topic Details': 'Define Direction',
    'Content Brief': 'Establish Requirements',
    'Preferences': 'Configure Parameters',
    'Content Outline': 'Structure Framework'
  };


  //Preferences step - UI-only placeholders, no backend support yet
  wordCountOptions: string[] = ['500', '1000', '1500'];
  wordCountPlaceholder: string = '500';
  authorNamePlaceholder: string = '';
  // Every entry in the Author dropdown is just a name, so authorNamePlaceholder remains the only
  // stored value. Manually added names are appended here so they render like any other option.
  authorOptions: string[] = [];
  loggedInAuthorName: string = '';
  showManualAuthorPanel: boolean = false;
  manualAuthorName: string = '';

  //Content Outline step - the structure returned by api/Article/GenerateContentOutline, editable
  //on screen before the article is generated against it.
  //Offered only for the long-form article templates a heading structure is meaningful for;
  //ids per the template library: Blog 1, How To 2, Listicle 3.
  private readonly outlineEnabledTemplateIds: number[] = [1, 2, 3];
  outlineSections: ContentOutlineSection[] = [];
  isGeneratingOutline: boolean = false;
  outlineGenerated: boolean = false;
  //Set when the generation failed or came back empty, so the step offers a retry instead of
  //silently showing an empty outline.
  outlineError: string = '';
  //The article level read that came back with the outline. Not shown on the step - it goes back
  //with the final generation so the article is written to the same brief the outline was planned to.
  outlineTitle: string = '';
  outlinePurpose: string = '';
  outlineFormat: string = '';
  // Same tip source as the generation-in-progress popup, so the inline loader rotates the same content.
  outlineTips: AIWaitingInfo[] = [];
  activeOutlineTipIndex: number = 0;
  private outlineTipInterval: any = null;

  ngOnInit() {
    this.loadTopicSuggestions();
    this.loadProfileAuthors();
    this.articleService.getAgenticGenerationConfig().subscribe((config: AgenticGenerationConfig) => {
      this.agenticGenerationConfig = config ?? new AgenticGenerationConfig();
    });
    this.targetAudienceUrl = this._storageHelper.user.returnUrl + this._storageHelper.user.targetAudienceUrl;
    this.brandVoiceUrl = this._storageHelper.user.returnUrl + this._storageHelper.user.brandVoiceUrl;

    this.commonService.getUserInfoValue().subscribe((res: UserInfo) => {
      if (res != null) {
        this.isSaasUser = res.isSaasUser;
        this.loggedInAuthorName = [res.userFirstName, res.userLastName]
          .map(part => (part ?? '').trim())
          .filter(part => part.length > 0)
          .join(' ');
        this.applyLoggedInAuthor();
        this.hasKeywordPlanner = res.featureIds.includes(FEATURES.KeyWordPlannerFeatureName);
        this.isSettingsEnableKnowledgeVault = res.enableKnowledgeVault;
      }
    });

    // for keywords
    this.currentSelectedTopicData.keywords = this.currentSelectedTopicData.keywords ? this.currentSelectedTopicData.keywords.map(keyword => keyword.toLowerCase()) : [];
    this.selectedKeywords = this.currentSelectedTopicData.keywords ? this.currentSelectedTopicData.keywords.slice(0, 6) : [];
    if (this.campaignData != null && this.campaignData.keywords && this.campaignData.keywords.length>0) {
      this.selectedKeywords = this.campaignData.keywords ? this.campaignData.keywords.slice(0, 6) : [];
    }
    // for prompts - seeded for any caller that hands them in (GEO), the way keywords are above.
    // Regenerate re-applies these below; this covers the first-generation flows it does not reach.
    this.selectedPrompts = (this.mwcModalData.AIData.prompts && this.mwcModalData.AIData.prompts.length > 0)
      ? [...this.mwcModalData.AIData.prompts].slice(0, this.maxPromptsAllowed)
      : [];
    // An article added from inside a campaign reuses the prompts the campaign was created with,
    // the same way it reuses the campaign's keywords above.
    if (this.selectedPrompts.length === 0 && this.campaignData?.prompts?.length > 0) {
      this.selectedPrompts = [...this.campaignData.prompts].slice(0, this.maxPromptsAllowed);
    }
    let answer0 = "", answer1 = "", answer2 = "";
    if (this.mwcModalData.isRegenerateFlow) {
      this.isRegenerateFlow = true;

   
      const selectedGoal = this.mwcModalData.AIData.topicIdea.contentOutlineGoal && this.mwcModalData.AIData.topicIdea.contentOutlineGoal !== 'null' ? this.mwcModalData.AIData.topicIdea.contentOutlineGoal : "Brand Awareness";
      if (selectedGoal != null && selectedGoal != "") {
        this.goalsList.forEach((goal) => {
          goal.isSelectedGoal = false;
          if (goal.title == selectedGoal) {
            goal.isSelectedGoal = true;
          }
        });
      }
      this.selectedGoalDetail = this.goalsList.find(x => x.isSelectedGoal);

      this.isGenericFlow = this.mwcModalData.AIData.topicIdea.isGenericFlow === 'true' ? true : false;
      // Restore the Knowledge Vault choice the article was originally generated with, so revising it
      // does not silently drop back to off. Drives both the switch and the retrieval in generateArticle.
      // Skipped when the setting is off for the profile, since the switch is hidden in that case.
      this.isKnowledgeVaultEnable = this.isSettingsEnableKnowledgeVault && this.mwcModalData.AIData.topicIdea.isKnowledgeVaultEnable === 'true';
      this.selectedValueProjectType = this.mwcModalData.AIData.topicIdea.projectType && this.mwcModalData.AIData.topicIdea.projectType !== 'null' ? this.mwcModalData.AIData.topicIdea.projectType : "Blog";
      this.selectedKeywords = this.mwcModalData.AIData.topicIdea.keywords;
      this.selectedPrompts = (this.mwcModalData.AIData.prompts && this.mwcModalData.AIData.prompts.length > 0)
        ? [...this.mwcModalData.AIData.prompts]
        : [];
      this.selectedBrandVoice = this.mwcModalData.AIData.topicIdea.bvId.toString();
      this.selectedTargetAudience = this.mwcModalData.AIData.topicIdea.taId.toString();
      this.selectedValueLanguage = this.mwcModalData.AIData.topicIdea.language && this.mwcModalData.AIData.topicIdea.language !== 'null' ? this.mwcModalData.AIData.topicIdea.language : "US";
      if (this.mwcModalData.AIData.topicIdea.userContext != null && this.mwcModalData.AIData.topicIdea.userContext != "") {
        let parts = this.mwcModalData.AIData.topicIdea.userContext.split("$$");

        answer0 = parts[0] || "";
        answer1 = parts[1] || "";
        answer2 = parts[2] || "";
      }
    }
    // for other controls
    this.generateAiForm = this.fb.group({
      contextUrl: new UntypedFormControl(
            '',
            {
              validators: [
                Validators.required,
                this.urlValidator.bind(this),
                this.emptyUrlValidator.bind(this),
                this.urlLengthValidator.bind(this),
                this.nonHtmlResourceValidator.bind(this)
              ],
              asyncValidators: [this.urlAccessibilityValidator.bind(this)]
            }
      ),
      description: [this.currentSelectedTopicData.pillarIdea ? this.toTitleCase(this.currentSelectedTopicData.pillarIdea) : ''],
      contentBrief: new UntypedFormControl(),
      tone: new UntypedFormControl(this.selectedValueTone),
      language: new UntypedFormControl(this.selectedValueLanguage, []),
      projectType: new UntypedFormControl("Blog", []),
      contentOutlineGoal: new UntypedFormControl('', []),
      gender: new UntypedFormControl(this.selectedValueGender),
      ageGroup: new UntypedFormControl(this.selectedValueAgeGroup),
      interestsPersonals: new UntypedFormControl(this.selectedValueInterestAndPersona),
      aiEngine: new UntypedFormControl("_openAI", []),
      coreTopic: [this.currentSelectedTopicData.coreTopic ? this.toTitleCase(this.currentSelectedTopicData.coreTopic) : ''],
      brandVoice: this.selectedBrandVoice,
      brandVoiceDocument: "",
      brandVoiceDetails: null,
      brandVoiceId: 0,
      targetAudience: this.selectedTargetAudience,
      targetAudienceId: 0,
      targetAudienceDetails: null,
      aboutHPC: new UntypedFormControl(),
      aboutRL: new UntypedFormControl(),
      contentAS: new UntypedFormControl(),
      AnswerAI0: new UntypedFormControl(answer0, [this.maxWordsValidator(this.contentBriefMaxWords)]),
      AnswerAI1: new UntypedFormControl(answer1, [this.maxWordsValidator(this.contentBriefMaxWords)]),
      AnswerAI2: new UntypedFormControl(answer2, [this.maxWordsValidator(this.contentBriefMaxWords)]),
      FirstAnswer: new UntypedFormControl('', [this.maxWordsValidator(this.contentBriefMaxWords)]),
      SecondAnswer: new UntypedFormControl('', [this.maxWordsValidator(this.contentBriefMaxWords)]),
      ThirdAnswer: new UntypedFormControl('', [this.maxWordsValidator(this.contentBriefMaxWords)]),
      serviceName: new UntypedFormControl(),
      websiteParentUrl: new UntypedFormControl('', [Validators.pattern('^(https?:\\/\\/)?([\\w\\-]+\\.)+\\w{2,}(\\/\\S*)?$')]),
      individualUrls: new UntypedFormControl('',[this.multiUrlValidator]),
      instructions: new UntypedFormControl(''),
      contextText: new UntypedFormControl(''),
      isKnowledgeVaultEnable: [this.isKnowledgeVaultEnable],
      isInternalLinksEnable: [this.isInternalLinksEnable]
    });

    if (this.youtubeSummaryContent) {
      this.generateAiForm.get('contextUrl')?.setValidators([
        Validators.required,
        this.youtubeUrlValidator(true)
      ]);
    } else {
      this.generateAiForm.get('contextUrl')?.setValidators([
        Validators.required,
        Validators.pattern('^(https?:\\/\\/)?([\\w\\-]+\\.)+\\w{2,}(\\/\\S*)?$')
      ]);
    }

    this.generateAiForm.get('contextUrl')?.updateValueAndValidity();

    if (this.campaignData != null && this.campaignData.CampaignTopic && this.campaignData.CampaignTopic!=null) {
      //this.generateAiForm.get('coreTopic')?.setValue(this.campaignData.CampaignTopic);
      //this.generateAiForm.get('description')?.setValue(this.campaignData.CampaignTopic);
      this.inputText = this.campaignData.CampaignTopic;
    }
    // Article Ideas hands in a topic but no prompts - fill the prompts with suggestions for it,
    // so the user starts from a populated list instead of having to run Discover Prompts.
    if (!this.isRegenerateFlow && !this.isGenericFlow && this.campaignData == null && this.currentSelectedTopicData?.pillarIdea) {
      this.prepopulatePrompts(this.currentSelectedTopicData.pillarIdea);
    }
    // if(!this.isGenericFlow){
    //   this.generateAiForm.controls["description"].disable();
    // }
    // fill interest and persona === targetAudience from API
    this.FillInterestAndPersona();
    this.articleService.IsContentIntelligenceEnabledObjectObservable.subscribe(res => {
      this.isContentIntelligenceEnabled = res;
    });
    //this.cms.getCmsSiteConfig().then(siteConfig => {
    //  if (siteConfig && siteConfig.mlTranslationEnableLangauges && siteConfig.mlTranslationEnableLangauges.length > 0) {
    //    const langCode = siteConfig.mlTranslationEnableLangauges[0].languageCode;
    //    if (langCode) {
    //      const matchingProvince = this.provinceData.find(ele => ele.languageCode === langCode);
    //      this.selectedValueLanguage = matchingProvince ? matchingProvince.value : '';
    //    }
    //  }
    //}).catch(error => {
    //  console.error('Error fetching CMS site configuration:', error);
    //});

    this.fetchBrandVoices();
    this.fetchTargetAudiences();
    //this.contentTextData = this.UpdateTextByContent(this.selectedTemplateTitle);
    this.updateTextareaScroll();
    this.clickCount = 0;

    this.getAllTemplatesAndSettings();
    //upload data reset
    this.fileList = [];
    const urlControl = this.generateAiForm.controls.contextUrl;
    urlControl.valueChanges
    .pipe(
      debounceTime(600),           
      distinctUntilChanged(),
      filter(value => !!value),    
      tap(() => {
        urlControl.markAsTouched();
      })
    )
    .subscribe(() => {
      urlControl.updateValueAndValidity({ onlySelf: true });
    });

    this.knowledgeVaultVisibility = true;

  }

  urlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const url = control.value;
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/\S*)?$/;
    const isValid = urlPattern.test(url);
    if (!isValid) return { invalidUrl: true };
    return null;
  }

  urlLengthValidator(control: AbstractControl): ValidationErrors | null {
      const val = (control.value || '').trim();
      if (!val) return null; // empty handled by emptyUrlValidator
      return val.length > 2048 ? { urlTooLong: true } : null;
  }

  nonHtmlResourceValidator(control: AbstractControl): ValidationErrors | null {
    const val = (control.value || '').trim();
    if (!val) return null; // empty handled elsewhere
    return this.isNonHtmlResource(val) ? { nonHtmlResource: true } : null;
  }

  isNonHtmlResource(rawUrl: string): boolean {
    try {
      const normalized = /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`;
      const u = new URL(normalized);
      const path = (u.pathname || '').toLowerCase();

      // Block common non-HTML resources: PDFs, images, archives
      const disallowedExt = /\.(pdf|png|jpe?g|gif|bmp|webp|svg|ico|tiff?|zip|rar|7z|tar|gz|tgz|bz2)$/i;
      return disallowedExt.test(path);
    } catch {
      // If it's not a valid URL, let the invalidUrl validator handle it
      return false;
    }
  }

  emptyUrlValidator(control: AbstractControl): ValidationErrors | null {
    if (this.isIndividualUrlVisible) return null;
      const val = (control.value || '').trim();
      return val.length === 0 ? { emptyUrl: true } : null;
  }

  get contextUrlControl() {
    return this.generateAiForm.controls.contextUrl;
  }

  urlToCrawl:string='';
  urlAccessibilityValidator(control: AbstractControl): Observable<ValidationErrors | null> {
    const value = (control.value || '').trim();
    if (!value) {
      return of(null);
    }
    if (control.invalid) {
      return of(null);
    }
    let req = new ValidateUrlRequest();
    req.urls = [value];
    return this.articleService.ValidateUrl(req).pipe(
      map(res => {
        this.urlToCrawl = res.urlValidations[0].responseUrl;
        const status = res?.urlValidations[0].urlStatusCode;
        if (status === 404 || status === 410) {
          return { pageNotFound: true };
        }
        if (status === 401 || status === 403) {
          return { accessRestricted: true };
        }
        if (status === 408 || status === 504 || status === 0) {
          return { timeout: true };
        }
        if (status >= 400) {
          return { genericError: true };
        }
        return null;
      }),
      catchError(() => of({ timeout: true }))
    );
  }  

  // Custom validator for YouTube URLs
  youtubeUrlValidator(youtubeRequired: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const url = control.value;
      if (!youtubeRequired || !url) return null;

      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/;
      const valid = youtubeRegex.test(url);
      return valid ? null : { youtubeUrl: 'Please use a valid Youtube URL' };
    };
  }

  fetchBrandVoices(isReload: boolean = false) {
    if (isReload) { this.filteredBrandVoiceList = []; this.brandVoiceList = []; }
    var brandVoiceListRequest = new GetBrandVoiceListRequest();
    brandVoiceListRequest.profileId = +this._storageHelper.user.pId;

    this.isLoading = true;
    this.articleService.GetBrandVoiceList(brandVoiceListRequest).subscribe((response: GetBrandVoiceListResponse) => {
      console.log(response);
      if (response.errorCode != 0 && !response.errorMessage) {
        //show error messages
      } else {
        if (response.totalRecords > 0) this.isNoCreateBrandVoice = false;
        response.brandVoices.forEach((brandVoice: BrandVoice) => {
          if (brandVoice.isDefault) {
            this.isDefaultBVAvailable = true;
            this.defaultBVId = brandVoice.brandVoiceId;
          }
          this.brandVoiceList.push({
            label: brandVoice.title, value: brandVoice.brandVoiceId.toString(), tone: brandVoice.thingBrandVoice.thingJson.voiceTone, createdOn: brandVoice.createdDate.toString(), createdBy: brandVoice.authorName, brandVoiceDocument: brandVoice.thingBrandVoice.thingJson.brandVoiceDocument, details: brandVoice.thingBrandVoice.thingJson, isDefault: brandVoice.isDefault, isSelectedBV: false
          })
        });
        this.filteredBrandVoiceList = this.brandVoiceList;
        let data;
        if (this.isDefaultBVAvailable && this.defaultBVId != 0) {
          if (!this.isRegenerateFlow) {
            data = this.brandVoiceList.filter(item => { if (item.value == this.defaultBVId.toString()) return item })[0];
          } else {
            data = this.brandVoiceList.filter(item => { if (item.value == this.mwcModalData.AIData.topicIdea.bvId.toString()) return item })[0];
            this.filteredBrandVoiceList = this.filteredBrandVoiceList.map(item => ({
              ...item,
              isDefault: false,
              isSelectedBV: item.value === this.mwcModalData.AIData.topicIdea.bvId.toString()
            }));
          }

          if (data != null && data != undefined) {
            this.brandVoiceDetails = data;
            this.generateAiForm.patchValue(
              {
                brandVoiceDocument: data.brandVoiceDocument,
                brandVoiceDetails: data.details,
                brandVoiceId: +data.value
              }
            );
              this.selectedBrandVoice = data.value;
          }
        }
        if (this.campaignData != null && this.campaignData.brandVoiceId && this.campaignData.brandVoiceId != 0) {
          let data = this.brandVoiceList.filter(item => { if (item.value == this.campaignData.brandVoiceId.toString()) return item })[0];
          if (data != null && data != undefined) {
            this.isDefaultBVAvailable = false;
            this.defaultBVId = 0;
            this.brandVoiceDetails = data;
            this.generateAiForm.patchValue(
              {
                brandVoiceDocument: data.brandVoiceDocument,
                brandVoiceDetails: data.details,
                brandVoiceId: +data.value
              }
            );
            this.selectedBrandVoice = data.value;
            this.filteredBrandVoiceList = this.filteredBrandVoiceList.map(item => ({
              ...item,
              isDefault: false,
              isSelectedBV: item.value === this.campaignData.brandVoiceId.toString()
            }));
          }
        }
      }
      this.isLoading = false;
    }, (error: any) => {
      this.isLoading = false;
    });
  }

  fetchTargetAudiences(isReload: boolean = false) {
    if (isReload) this.targetAudienceList = []; this.filteredTargetAudienceList = [];
    var targetAudienceListRequest = new GetTargetAudienceListRequest();
    targetAudienceListRequest.profileId = +this._storageHelper.user.pId;

    this.isLoading = true;
    this.articleService.GetTargetAudienceList(targetAudienceListRequest).subscribe((response: GetTargetAudienceListResponse) => {
      console.log(response);
      if (response.errorCode != 0 && !response.errorMessage) {
        //show error messages
      } else {
        if (response.totalRecords > 0) this.isNoTargetAudience = false;
        response.targteAudiences.forEach((targetAudience: TargetAudience) => {
          if (targetAudience.isDefault) {
            this.isDefaultTAAvailable = true;
            this.defaultTAId = targetAudience.targetAudienceId;
          }
          this.targetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": targetAudience.isDefault,
            "isSelectedTA": false
          });
        });
        this.filteredTargetAudienceList = this.targetAudienceList;
        if (this.isRegenerateFlow) {
          this.defaultTAId = this.mwcModalData.AIData.topicIdea.taId;
          this.filteredTargetAudienceList = this.filteredTargetAudienceList.map(item => ({
            ...item,
            isDefault: false,
            isSelectedTA: item.targetAudienceId === this.mwcModalData.AIData.topicIdea.taId
          }));
        }
        if (this.isDefaultTAAvailable && this.defaultTAId != 0) {
          let data = this.targetAudienceList.filter(item => { if (item.targetAudienceId == this.defaultTAId) return item })[0];
          if (data != null && data != undefined) {
            this.targetAudienceDetails = data;
            this.generateAiForm.patchValue(
              {
                targetAudienceDetails: data.thingTargetAudience.thingJson,
                targetAudienceId: +data.targetAudienceId
              }
            );
          }
          this.selectedTargetAudience = data.title;
        }
        if (this.campaignData != null && this.campaignData.targetAudienceId && this.campaignData.targetAudienceId != 0) {
          let data = this.targetAudienceList.filter(item => { if (item.targetAudienceId == this.campaignData.targetAudienceId) return item })[0];
          if (data != null && data != undefined) {
            this.isDefaultTAAvailable = false;
            this.defaultTAId = 0;
            this.targetAudienceDetails = data;
            this.generateAiForm.patchValue(
              {
                targetAudienceDetails: data.thingTargetAudience.thingJson,
                targetAudienceId: +data.targetAudienceId
              }
            );
          }
          this.selectedTargetAudience = data.title;
          this.filteredTargetAudienceList = this.filteredTargetAudienceList.map(item => ({
            ...item,
            isDefault: false,
            isSelectedTA: item.targetAudienceId === this.campaignData.targetAudienceId
          }));
        }
      }
      this.isLoading = false;
    }, (error: any) => {
      this.isLoading = false;
    });
  }

  private toTitleCase(text: string): string {
    return text.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  public FillInterestAndPersona() {
    let targetAudiencesRequest = new GetAudiencesRequest();
    targetAudiencesRequest.ProfileId = this._storageHelper.user.pId;
    this.topicService.GetAudiences(targetAudiencesRequest).subscribe((response: GetAudiencesResponseType) => {
      if (response.audiences && response.audiences.length > 0) {
        response.audiences.forEach(element => {
          this.interestsPersonalsList.push({
            label: element,
            value: element
          });
        });
      }
    })
  }

  public generateArticle(isOutlineCreation: boolean = false, templateData: Template = null, skipRegenerateCheck: boolean = false) {
    if (this.isKnowledgeVaultEnable) {
      const pillarIdea = this.generateAiForm.controls['description']?.value;
      const coreTopic = this.generateAiForm.controls['coreTopic']?.value;

      if (pillarIdea && coreTopic) {
        this.callParallelChunks(pillarIdea, coreTopic, (result) => {
          this.KnowledgeVaultChunkData = result;
          this.executeArticleGeneration(isOutlineCreation, templateData, skipRegenerateCheck);
        });
      }
      else if (pillarIdea) {
        this.getChunksInfo(pillarIdea, (result) => {
          this.KnowledgeVaultChunkData = result;
          this.executeArticleGeneration(isOutlineCreation, templateData, skipRegenerateCheck);
        });
      }      
    }
    else {
      this.executeArticleGeneration(isOutlineCreation, templateData, skipRegenerateCheck);
    }    
  }

  private executeArticleGeneration(
    isOutlineCreation: boolean,
    templateData: Template,
    skipRegenerateCheck: boolean
  ) {

    if (this.isRegenerateFlow) {
      if (this.selectedIndex != (this.tabs.length - 1)) {
        this.processAction();
        return;
      }
    }
    if (templateData != null && this.selectedTemplateTitle !== 'FAQs' && this.selectedTemplateTitle !== 'Landing Page' && this.selectedTemplateTitle != 'Youtube Summary' && this.selectedTemplateTitle !== 'Bulk Meta Generator') {
      this.selectedTemplateId = templateData.templateId;
      this.selectedTemplateTitle = templateData.title;
    }
    if (this.showSelectTemplatesTab) {
      const templatesToGenerateWith = this.templatesList.filter(t => t.selected);
      if (templatesToGenerateWith.length > 0) {
        this.selectedTemplateId = templatesToGenerateWith[0].templateId;
        this.selectedTemplateTitle = templatesToGenerateWith[0].title;
        this.templatesForGeneration = templatesToGenerateWith;
      }
    }
    //this.templateHelperService.closeTemplateSelector();
    this.newTemplateHelperService.closeTemplateSelector();
    this.tracking.trackEvent(
      'pageview', `${this.isGenericFlow ? 'Generic Flow' : 'Content Intelligence Flow'} - ${isOutlineCreation ? 'Generate Outline' : 'Generate Article'}`
    );

    if (this.selectedKeywords.length > 0 || this.selectedTemplateTitle === 'Bulk Meta Generator') {

      let firstAIAnswer = (this.generateAiForm.controls["AnswerAI0"].value == null) ? "" : this.generateAiForm.controls["AnswerAI0"].value;
      let secondAIAnswer = (this.generateAiForm.controls["AnswerAI1"].value == null) ? "" : this.generateAiForm.controls["AnswerAI1"].value;
      let thirdAIAnswer = (this.generateAiForm.controls["AnswerAI2"].value == null) ? "" : this.generateAiForm.controls["AnswerAI2"].value;
      let firstGenAnswer = (this.generateAiForm.controls["FirstAnswer"].value == null) ? "" : this.generateAiForm.controls["FirstAnswer"].value;
      let secondGenAnswer = (this.generateAiForm.controls["SecondAnswer"].value == null) ? "" : this.generateAiForm.controls["SecondAnswer"].value;
      let thirdGenAnswer = (this.generateAiForm.controls["ThirdAnswer"].value == null) ? "" : this.generateAiForm.controls["ThirdAnswer"].value;

      this.contentBriefQA = (this.isQuestionExist) ? (firstAIAnswer + "" + secondAIAnswer + "" + thirdAIAnswer) : (firstGenAnswer + "" + secondGenAnswer + "" + thirdGenAnswer);
      if (this.selectedTemplateTitle === 'Marketing Brief') {
        this.contentBriefQA = (this.isQuestionExist) ? (firstAIAnswer + "$$" + secondAIAnswer + "$$" + thirdAIAnswer) : (firstGenAnswer + "$$" + secondGenAnswer + "$$" + thirdGenAnswer);
      }
      let spinner;
      if (!(this.isRegenerateFlow && !skipRegenerateCheck)) {
        this.modal.destroy();
        this.generationInProgressHelperService.openWaitingPopup([], isOutlineCreation ? 'Outline Generation in Progress...' : 'Generation in Progress...');
        spinner = { close: () => this.generationInProgressHelperService.closeTemplateSelector() };
      }
      this.isLoading = true;
      let language = this.provinceData.find((ele, index) => ele.value == this.generateAiForm.controls["language"].value).label;
      let topicIdeaPayloadForAIGeneration = new TopicIdeaPayloadForAIGeneration();
      if (this.campaignData != null) {
        topicIdeaPayloadForAIGeneration.campaignGoal = this.campaignData.campaignGoal;
        topicIdeaPayloadForAIGeneration.campaignId = this.campaignData.campaignId;
        topicIdeaPayloadForAIGeneration.campaignTopic = this.campaignData.CampaignTopic;
      }
      topicIdeaPayloadForAIGeneration.recreateContentDocument = this.fileContentForContentRevamp;
      topicIdeaPayloadForAIGeneration.topicIdea = this.mwcModalData.AIData.topicIdea;
      topicIdeaPayloadForAIGeneration.topicIdea.language = this.generateAiForm.controls["language"].value ? this.generateAiForm.controls["language"].value : "";
      topicIdeaPayloadForAIGeneration.topicIdea.pillarIdea = this.generateAiForm.controls["description"].value ? this.generateAiForm.controls["description"].value : "";
      topicIdeaPayloadForAIGeneration.topicIdea.coreTopic = this.generateAiForm.controls["coreTopic"].value ? this.generateAiForm.controls["coreTopic"].value : "";
      topicIdeaPayloadForAIGeneration.topicIdea.keywords = this.selectedKeywords;
      topicIdeaPayloadForAIGeneration.prompts = this.selectedPrompts ? [...this.selectedPrompts] : [];
      topicIdeaPayloadForAIGeneration.knowledgeChunkData = this.KnowledgeVaultChunkData;
      topicIdeaPayloadForAIGeneration.isKnowledgeVaultEnable = this.isKnowledgeVaultEnable;
      topicIdeaPayloadForAIGeneration.isInternalLinksEnable = this.isInternalLinksEnable;
      topicIdeaPayloadForAIGeneration.contentBrief = (this.isQuestionExist) ? (firstAIAnswer + "$$" + secondAIAnswer + "$$" + thirdAIAnswer) : (firstGenAnswer + "$$" + secondGenAnswer + "$$" + thirdGenAnswer);

      topicIdeaPayloadForAIGeneration.tone = this.generateAiForm.controls["tone"].value;
      topicIdeaPayloadForAIGeneration.language = language;
      topicIdeaPayloadForAIGeneration.projectType = this.generateAiForm.controls["projectType"].value;
      topicIdeaPayloadForAIGeneration.contentOutlineGoal = (this.selectedGoalDetail != undefined && this.selectedGoalDetail.title != undefined && this.selectedGoalDetail.title != null) ? this.selectedGoalDetail.title : "";
      topicIdeaPayloadForAIGeneration.gender = this.generateAiForm.controls["gender"].value;
      topicIdeaPayloadForAIGeneration.ageGroup = this.generateAiForm.controls["ageGroup"].value;
      topicIdeaPayloadForAIGeneration.interestAndPersona = this.generateAiForm.controls["interestsPersonals"].value;
      topicIdeaPayloadForAIGeneration.brandVoiceDocument = this.mwcModalData.AIData.brandVoiceDocument;
      topicIdeaPayloadForAIGeneration.isOutlineCreation = isOutlineCreation;
      topicIdeaPayloadForAIGeneration.isGenericFlow = this.isGenericFlow;
      topicIdeaPayloadForAIGeneration.templateId = this.selectedTemplateId;

      topicIdeaPayloadForAIGeneration.brandVoiceId = this.generateAiForm.controls["brandVoiceId"].value;
      topicIdeaPayloadForAIGeneration.brandVoiceDocument = this.generateAiForm.controls["brandVoiceDocument"].value;
      topicIdeaPayloadForAIGeneration.brandVoiceDetails = this.generateAiForm.controls["brandVoiceDetails"].value;
      topicIdeaPayloadForAIGeneration.targetAudienceId = this.generateAiForm.controls["targetAudienceId"].value;
      topicIdeaPayloadForAIGeneration.targetAudienceDetails = this.generateAiForm.controls["targetAudienceDetails"].value;
      topicIdeaPayloadForAIGeneration.templateTitle = this.selectedTemplateTitle;
      topicIdeaPayloadForAIGeneration.selectedTemplates = this.templatesForGeneration;
      topicIdeaPayloadForAIGeneration.intent = this.selectedGoalDetail?.title;
      topicIdeaPayloadForAIGeneration.wordCount = +this.wordCountPlaceholder;
      topicIdeaPayloadForAIGeneration.authorName = (this.authorNamePlaceholder ?? '').trim();
      topicIdeaPayloadForAIGeneration.contentBriefQuestions = this.getContentBriefQuestions();
      // The plan approved on the Content Outline step. Empty for the flows that have no outline
      // step, or when the user emptied it, and the prompts fall back to their own structure.
      topicIdeaPayloadForAIGeneration.contentOutline = this.getApprovedOutline();
      topicIdeaPayloadForAIGeneration.contentOutlineTitle = this.outlineTitle;
      topicIdeaPayloadForAIGeneration.contentOutlinePurpose = this.outlinePurpose;
      topicIdeaPayloadForAIGeneration.contentOutlineFormat = this.outlineFormat;

      let langDetail = new DocumentLanguage();
      langDetail.languageName = language;
      langDetail.languageCode = this.provinceData.find((ele, index) => ele.value == this.generateAiForm.controls["language"].value).languageCode;;
      langDetail.countryCode = this.generateAiForm.controls["language"].value;
      topicIdeaPayloadForAIGeneration.languageDetail = langDetail;
      try {

        //save default BV and TA only if they changed
        if (this.isDefaultBVAvailable && this.selectedBrandVoice != this.defaultBVId.toString()) {
          var defaultBrandVoiceForProfileRequest = new DefaultBrandVoiceForProfileRequest();
          defaultBrandVoiceForProfileRequest.brandVoiceId = +this.selectedBrandVoice;
          defaultBrandVoiceForProfileRequest.businessId = +this._storageHelper.user.bId;
          defaultBrandVoiceForProfileRequest.profileIds = [this._storageHelper.user.pId];
          this.articleService.assignDefaultBrandVoiceForProfile(defaultBrandVoiceForProfileRequest).subscribe();
        }

        if (this.isDefaultTAAvailable && this.targetAudienceDetails != null && this.targetAudienceDetails.targetAudienceId != this.defaultTAId) {
          var defaultTargetAudienceForProfileRequest = new DefaultTargetAudienceForProfileRequest();
          defaultTargetAudienceForProfileRequest.targetAudienceId = this.targetAudienceDetails.targetAudienceId;
          defaultTargetAudienceForProfileRequest.businessId = +this._storageHelper.user.bId;
          defaultTargetAudienceForProfileRequest.profileIds = [this._storageHelper.user.pId];
          this.articleService.assignDefaultTargetAudienceForProfile(defaultTargetAudienceForProfileRequest).subscribe();
        }
        if (this.selectedTemplateTitle === 'FAQs') {
          topicIdeaPayloadForAIGeneration.isFaqWorkflow = true;
        }
        if (this.selectedTemplateTitle === 'Landing Page') {
          topicIdeaPayloadForAIGeneration.isCustomTemplateWorkflow = true;
        }
        if (this.selectedTemplateTitle === 'Youtube Summary') {
          topicIdeaPayloadForAIGeneration.isYoutubeSummaryTemplateWorkflow = true;
        }
        topicIdeaPayloadForAIGeneration.serviceName = this.generateAiForm.controls["serviceName"].value ? this.generateAiForm.controls["serviceName"].value : "";
        if (this.selectedTemplateTitle === 'Bulk Meta Generator') {
          let urls = [];
          const individualUrls = this.generateAiForm?.controls?.["individualUrls"]?.value?.trim();
          const websiteParentUrl = this.generateAiForm?.controls?.["websiteParentUrl"]?.value?.trim();
          if (individualUrls) {
            urls = individualUrls
              .split(/[\n,]+/)
              .map(url => url.trim())
              .filter(url => url);
            topicIdeaPayloadForAIGeneration.isParentUrl = false;
          } else if (websiteParentUrl) {
            urls = [websiteParentUrl];
            topicIdeaPayloadForAIGeneration.isParentUrl = true;
          }
          if (topicIdeaPayloadForAIGeneration) {
            topicIdeaPayloadForAIGeneration.PageUrls = urls;
            topicIdeaPayloadForAIGeneration.contentBrief =
              this.generateAiForm?.controls?.["instructions"]?.value || "";
          }
        }

        if (this.isRegenerateFlow && !skipRegenerateCheck) {
          this.modal.destroy();
          topicIdeaPayloadForAIGeneration.isRegenerateFlow = true;
          this.articleService.setTopicIdeaPayloadForAIReviseAndGeneration(topicIdeaPayloadForAIGeneration);
          return;
        } else {
          topicIdeaPayloadForAIGeneration.isStreamFlow = true;
          this.articleService.setTopicIdeaPayloadForAIReviseAndGeneration(topicIdeaPayloadForAIGeneration);
        }

        const trackingEventProperties = new TrackEventProperties();
        trackingEventProperties.TemplateId = this.selectedTemplateId.toString();
        trackingEventProperties.TemplateType = this.selectedTemplateTitle;

        this.tracking.trackEvent(
          'pageview', this.selectedTemplateTitle + ' - Generate Clicked',
          trackingEventProperties
        );
        topicIdeaPayloadForAIGeneration.geoRecommendationId = this.geoRecommendationId;
        if (this.isAgenticGeneration(topicIdeaPayloadForAIGeneration)) {
          this.generateContentByAgent(topicIdeaPayloadForAIGeneration, spinner);
          return;
        }
        // generate with AI
        this.articleService.generateContentByAIForTopicIdea(topicIdeaPayloadForAIGeneration).subscribe((response: any) => {
          try {
            if (this.selectedTemplateTitle !== 'Bulk Meta Generator' && !response.contentResponse.contents && response.contentResponse.errorCode > 0) {
              throw new Error(JSON.stringify(response.contentResponse.errorMessage));
            }
            if (this.selectedTemplateTitle === 'Bulk Meta Generator') {
              if (this.router.url === "/manage-content/articles") {
                this.articleStoreService.triggerReload();
              } else {
                this.router.navigateByUrl("/manage-content/articles");
              }
              this.cdRef.detectChanges();
              this.modal.destroy();
              spinner.close();
              return;
            }
            // TODO: assign content to blog object here - only assigning body and title for now
            let postBody = response.contentResponse.contents[0].content;
            // const validJSON = postBody.replace(/([a-zA-Z0-9_]+?):/g, '"$1":');
            const parsedObject = JSON.parse(postBody);
            let article = new Article();
            let faqList = [];
            if (parsedObject && parsedObject.faqs && parsedObject.faqs.length > 0) {
              parsedObject.faqs.forEach((f => {
                const faq = new Faq();
                faq.questionText = f.question;
                const faqAnswer = new FaqAnswer();
                faqAnswer.howToSteps = [];
                faqAnswer.text = f.answer;
                const faqImage = new FaqImage();
                faqImage.url = "";
                faqImage.caption = "";
                faqImage.width = '100';
                faqImage.height = '100';
                faqAnswer.image = faqImage;
                faq.answer = faqAnswer;
                faq.questionId = 0;
                faq.status = FAQ.Status.Draft;
                faq.mappingId = null;
                faq.isAiFaq = true;
                faqList.push(faq)
              }))
            }
            if (faqList.length > 0) {
              article.faqs = faqList;
            }
            if (this.campaignData && this.campaignData != null) {
              article.campaignId = this.campaignData.campaignId;
              article.brandVoiceId = this.campaignData.brandVoiceId;
              article.targetAudienceId = this.campaignData.targetAudienceId;
            }
            article.isPublishable = this.isPublishable;
            article.title = parsedObject.PostTitle;
            article.content = parsedObject.BodySection;
            article.keyPhrase = this.selectedKeywords ? this.noTilde(this.selectedKeywords[0]) : "";
            article.metaTitle = parsedObject.MetaTitle;
            article.metaDescription = parsedObject.MetaDescription;
            article.snippet = parsedObject.PostSummary;
            article.slugUrl = this.noTilde(parsedObject.UrlSlug);
            article.tagsList = parsedObject.Tags;
            article.tone = this.generateAiForm.controls["tone"].value;
            article.language = this.generateAiForm.controls["language"].value;
            article.promptProperties = new PromptProperties();
            article.promptProperties.isGenericFlow = this.isGenericFlow ? "true" : "false";
            article.promptProperties.isKnowledgeVaultEnable = this.isKnowledgeVaultEnable ? "true" : "false";
            article.promptProperties.isInternalLinksEnable = this.isInternalLinksEnable ? "true" : "false";
            article.promptProperties.projectType = this.generateAiForm.controls["projectType"].value;
            article.promptProperties.contentOutlineGoal = (this.selectedGoalDetail != undefined && this.selectedGoalDetail.title != undefined && this.selectedGoalDetail.title != null) ? this.selectedGoalDetail.title : "";
            article.promptProperties.intent = topicIdeaPayloadForAIGeneration.topicIdea.intent;
            article.promptProperties.pillarIdea = topicIdeaPayloadForAIGeneration.topicIdea.pillarIdea;
            article.promptProperties.coreTopic = topicIdeaPayloadForAIGeneration.topicIdea.coreTopic;
            article.promptProperties.keywords = topicIdeaPayloadForAIGeneration.topicIdea.keywords.join();
            article.promptProperties.promptsUsed = (this.selectedPrompts && this.selectedPrompts.length > 0) ? this.selectedPrompts.join('|||') : "";
            article.promptProperties.userContext = (this.isQuestionExist) ? (firstAIAnswer + "$$" + secondAIAnswer + "$$" + thirdAIAnswer) : (firstGenAnswer + "$$" + secondGenAnswer + "$$" + thirdGenAnswer);
            article.templateId = response.templateId;
            article.targetAudienceId = response.targetAudienceId;
            article.brandVoiceId = response.brandVoiceId;
            article.articleId = response.articleId;
            article.templateTitle = response.templateTitle;
            let docDetail = new DocumentDetail();
            docDetail.documentId = response.documentId;
            let languageCode = this.provinceData.find((ele) => ele.value == this.generateAiForm.controls["language"].value)?.languageCode;
            let languageName = this.provinceData.find((ele) => ele.value == this.generateAiForm.controls["language"].value)?.label;
            let countryCode = this.generateAiForm.controls["language"].value;
            let lang = new DocumentLanguage();
            lang.languageCode = languageCode;
            lang.languageName = languageName;
            lang.countryCode = countryCode;
            docDetail.documentLanguage = lang;
            if (!article.documentsDetail) {
              article.documentsDetail = [];
            }
            docDetail.status = 'done';
            article.documentsDetail.push(docDetail);
            this.articleStoreService.updateState(article);
            this.modal.destroy();
            spinner.close();
            this.isLoading = true;
            var createdArticleId = response.articleId;
            this.cdRef.detectChanges();
            if (this.campaignData && this.campaignData != null) {
              this.router.navigateByUrl(`/manage-content/articles/create-detailed-post/edit/${createdArticleId}?campaignId=${this.campaignData.campaignId}`);
            } else {
              this.router.navigateByUrl(`/manage-content/articles/create-detailed-post/edit/${createdArticleId}`);
            }
          } catch (error) {
            spinner.close();
            this.isLoading = false;
            console.log(error);
            topicIdeaPayloadForAIGeneration.language = this.generateAiForm.controls["language"].value;
            this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, error, null, topicIdeaPayloadForAIGeneration)
          }
        }, (error: HttpErrorResponse) => {
          spinner.close();
          this.isLoading = false;
          console.log(error);
          topicIdeaPayloadForAIGeneration.language = this.generateAiForm.controls["language"].value;
          this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, error, null, topicIdeaPayloadForAIGeneration)
        })
      } catch (error) {
        spinner.close();
        this.isLoading = false;
        console.log(error);
        topicIdeaPayloadForAIGeneration.language = this.generateAiForm.controls["language"].value;
        this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, error, null, topicIdeaPayloadForAIGeneration)
      }
    }
    else {
      this.message.create('error', "Atleast one keyword is required content generation.");
    }
    
  }


  // Agentic profiles generate in the background (Function + AI-Agent), except custom templates
  // (webpages), the excluded templates, regenerate and outline-only creation, which keep the existing flow.
  private isAgenticGeneration(payload: TopicIdeaPayloadForAIGeneration): boolean {
    const config = this.agenticGenerationConfig;
    if (!config?.isEnabled || this.isRegenerateFlow || payload.isCustomTemplateWorkflow || payload.isOutlineCreation) {
      return false;
    }
    return !(config.excludedTemplates ?? []).some(t => t?.toLowerCase() === (payload.templateTitle ?? '').toLowerCase());
  }

  private generateContentByAgent(payload: TopicIdeaPayloadForAIGeneration, spinner: { close: () => void }) {
    // The editor must not start the streaming flow for this payload - the agent writes the content.
    this.articleService.setTopicIdeaPayloadForAIReviseAndGeneration(null);
    this.articleService.generateContentByAgent(payload).subscribe({
      next: (response: AgenticGenerationResponse) => {
        spinner.close();
        this.isLoading = false;
        this.modal.destroy();
        this.notification.snackbarSuccess("Your content is being generated. It will be ready in the content list shortly.");
        if (this.router.url === "/manage-content/articles") {
          this.articleStoreService.triggerReload();
        } else {
          this.router.navigateByUrl("/manage-content/articles");
        }
        this.cdRef.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        spinner.close();
        this.isLoading = false;
        console.log(error);
        payload.language = this.generateAiForm.controls["language"].value;
        this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_TOPIC_IDEA_AI_GENERATION_MODAL, error, null, payload);
      }
    });
  }

  public onBriefSwitchChanged(event) {
    this.isContentBriefEnabled = event;
    this.cdRef.detectChanges();
  }
  validatetagTone(control: UntypedFormControl) {
    let isValidtone = control.value.length > 0;
    let isValid = !isValidtone;
    return isValid ? { isValidtone: true } : null;
  }
  toggelAdvancedSettings() {
    this.tracking.trackEvent(
      'pageview', 'Advanced (Inside Prompt)'
    );
    this.isadvancedSettingsShow = !this.isadvancedSettingsShow;
  }

  removeKeyword(removeKeyword: {}): void {
    this.selectedKeywords = this.selectedKeywords.filter(selectedKeyword => selectedKeyword !== removeKeyword);
  }

  sliceKeyword(selectedKeyword: string): string {
    const isLongKeyword = selectedKeyword.length > 20;
    return isLongKeyword ? `${selectedKeyword.slice(0, 20)}...` : selectedKeyword;
  }

  showKeywordInput(): void {
    this.keywordInputVisible = true;
    setTimeout(() => {
      this.inputElement?.nativeElement.focus();
    }, 10);
  }

  addKeywordToSelectedKeywords(): void {
    if (this.selectedKeywordInputValue && this.selectedKeywords.indexOf(this.selectedKeywordInputValue) === -1) {
      this.selectedKeywords = [...this.selectedKeywords, this.selectedKeywordInputValue];
    }
    this.selectedKeywordInputValue = '';
    this.keywordInputVisible = false;
  }

  removePrompt(prompt: string): void {
    this.selectedPrompts = this.selectedPrompts.filter(p => p !== prompt);
  }

  showPromptInput(): void {
    this.promptInputVisible = true;
    setTimeout(() => {
      this.promptInputElement?.nativeElement.focus();
    }, 10);
  }

  addPromptToSelectedPrompts(): void {
    if (this.selectedPromptInputValue && this.selectedPrompts.indexOf(this.selectedPromptInputValue) === -1) {
      this.selectedPrompts = [...this.selectedPrompts, this.selectedPromptInputValue];
    }
    this.selectedPromptInputValue = '';
    this.promptInputVisible = false;
  }

  applyTopicSuggestion(suggestion: string): void {
    this.inputText = suggestion;
    this.generateAiForm.get('description')?.setValue(suggestion);
  }

  refreshTopicSuggestions(): void {
    if (this.isTopicSuggestionsLoading) {
      return;
    }
    // The pool is only empty if the first load returned nothing or failed, so retry the call rather
    // than leaving the refresh button doing nothing.
    if (this.topicSuggestionPool.length === 0) {
      this.loadTopicSuggestions();
      return;
    }
    this.pickTopicSuggestions();
    this.cdRef.detectChanges();
  }

  private loadTopicSuggestions(): void {
    this.isTopicSuggestionsLoading = true;

    let request: GetTopicIdeaListRequest = new GetTopicIdeaListRequest();
    request.profileId = this._storageHelper.user.pId;
    // Ideas the user has not already acted on, highest search volume first - the same set and order
    // the Recommended Topics screen shows.
    request.isDone = false;
    request.isDismissed = false;
    request.isFavourite = false;
    request.pageNumber = 1;
    request.pageSize = this.topicSuggestionPoolSize;
    request.orderBy = "searchVol";
    request.sortingOrder = "desc";

    this.topicService.GetTopicIdeaList<GetTopicIdeaListResponse>(request).subscribe((response: GetTopicIdeaListResponse) => {
      if (response != null && response.errorCode == 0 && response.topicIdeas != null) {
        // Distinct, because the same pillar idea can appear against more than one core topic and a
        // repeated chip inside a set of three is very visible.
        this.topicSuggestionPool = Array.from(new Set(
          response.topicIdeas
            .map(topic => topic.pillarIdea)
            .filter(pillarIdea => !!pillarIdea && pillarIdea.trim().length > 0)
        ));
        this.shownTopicSuggestions.clear();
        this.pickTopicSuggestions();
      }
      this.isTopicSuggestionsLoading = false;
      this.cdRef.detectChanges();
    }, (error) => {
      console.log(error);
      this.isTopicSuggestionsLoading = false;
      this.cdRef.detectChanges();
    });
  }

  // Draws the next three at random from what has not been shown. Once every topic has been seen the
  // history resets, so refreshing keeps working however many times it is clicked.
  private pickTopicSuggestions(): void {
    let available = this.topicSuggestionPool.filter(topic => !this.shownTopicSuggestions.has(topic));
    if (available.length < this.topicSuggestionCount) {
      this.shownTopicSuggestions.clear();
      available = this.topicSuggestionPool.slice();
    }

    const picked: string[] = [];
    while (picked.length < this.topicSuggestionCount && available.length > 0) {
      const index = Math.floor(Math.random() * available.length);
      const topic = available.splice(index, 1)[0];
      picked.push(topic);
      this.shownTopicSuggestions.add(topic);
    }

    this.topicSuggestions = picked;
  }

  showPromptUpload(): void {
    this.isPromptTagsVisible = false;
    this.isPromptUploadVisible = true;
  }

  showPromptManual(): void {
    this.isPromptTagsVisible = true;
    this.isPromptUploadVisible = false;
  }

  showKeywordUpload(): void {
    this.isKeywordTagsVisible = false;
    this.isKeywordUploadVisible = true;
  }

  showKeywordManual(): void {
    this.isKeywordTagsVisible = true;
    this.isKeywordUploadVisible = false;
  }

  private setSampleUploadError(documentType: 'keywords' | 'prompts', error: UploadValidationError | null): void {
    if (documentType === 'prompts') {
      this.promptUploadError = error;
    } else {
      this.keywordUploadError = error;
    }
  }

  private isValidSampleFile(file: File, documentType: 'keywords' | 'prompts'): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!extension || !this.allowedSampleFileExtensions.includes(extension)) {
      this.setSampleUploadError(documentType, {
        title: `Unsupported file format (.${extension || file.name.split('.').pop()})`,
        description: 'Please upload an XLSX, XLS or CSV file instead.'
      });
      return false;
    }
    if (file.size < this.minSampleFileSize) {
      this.setSampleUploadError(documentType, {
        title: 'Empty file',
        description: 'The selected file appears to be empty. Please choose a file with content.'
      });
      return false;
    }
    if (file.size > this.maxSampleFileSize) {
      this.setSampleUploadError(documentType, {
        title: 'File too large',
        description: 'Please upload a file under 5 MB.'
      });
      return false;
    }
    return true;
  }

  // Mirrors the animated progress used for the Web Pages workflow's keyword/prompt uploads
  // (custom-template-workflow-tabset) - the actual upload call has no progress events of its
  // own, so the bar is a fixed-duration animation run alongside it.
  private animateSampleUploadProgress(documentType: 'keywords' | 'prompts'): void {
    const totalDuration = 2000; // 2 seconds
    const steps = 20;
    const stepTime = totalDuration / steps;
    if (documentType === 'prompts') {
      this.promptUploadPercent = 0;
    } else {
      this.keywordUploadPercent = 0;
    }
    interval(stepTime)
      .pipe(take(steps + 1))
      .subscribe((step) => {
        const percentDone = Math.min(Math.round((step / steps) * 100), 100);
        if (documentType === 'prompts' && this.promptSampleFile) {
          this.promptUploadPercent = percentDone;
        } else if (documentType === 'keywords' && this.keywordSampleFile) {
          this.keywordUploadPercent = percentDone;
        }
        this.cdRef.detectChanges();
      });
  }

  removePromptSampleFile(): void {
    this.promptSampleFile = null;
    this.promptUploadPercent = null;
    this.promptUploadError = null;
    this.cdRef.detectChanges();
  }

  removeKeywordSampleFile(): void {
    this.keywordSampleFile = null;
    this.keywordUploadPercent = null;
    this.keywordUploadError = null;
    this.cdRef.detectChanges();
  }

  // Helper to format file size (mirrors custom-template-workflow-tabset's formatFileSize)
  formatSampleFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  onPromptFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) {
      return;
    }
    this.promptUploadError = null;
    if (!this.isValidSampleFile(file, 'prompts')) {
      return;
    }
    this.promptSampleFile = file;
    this.animateSampleUploadProgress('prompts');
    this.onUploadPromptsClick();
  }

  onKeywordFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) {
      return;
    }
    this.keywordUploadError = null;
    if (!this.isValidSampleFile(file, 'keywords')) {
      return;
    }
    this.keywordSampleFile = file;
    this.animateSampleUploadProgress('keywords');
    this.onUploadKeywordsClick();
  }

  onUploadPromptsClick(): void {
    this.uploadSample(this.promptSampleFile, 'prompts');
  }

  onUploadKeywordsClick(): void {
    this.uploadSample(this.keywordSampleFile, 'keywords');
  }

  // Parsed values land in the same arrays the manual tag input feeds, so they render straight
  // into the Add Prompts / Add Keywords boxes.
  private uploadSample(file: File | null, documentType: 'keywords' | 'prompts'): void {
    if (!file) {
      return;
    }
    const templateId = this.mwcModalData?.AIData?.templateId || 0;
    this.campaignService.uploadKeywordDocument(file, documentType, templateId)
      .pipe(take(1)).subscribe({
        next: (response) => {
          if (response?.success && response.items?.length) {
            if (documentType === 'prompts') {
              this.selectedPrompts = response.items.slice(0, this.maxPromptsAllowed);
              this.promptUploadPercent = null;
              this.showPromptManual();
            } else {
              this.selectedKeywords = response.items.slice(0, this.maxKeywordsAllowed);
              this.keywordUploadPercent = null;
              this.showKeywordManual();
            }
          } else {
            if (documentType === 'prompts') {
              this.promptSampleFile = null;
              this.promptUploadPercent = null;
              this.promptUploadError = { title: 'Upload failed', description: response?.message || 'The file could not be read.' };
            } else {
              this.keywordSampleFile = null;
              this.keywordUploadPercent = null;
              this.keywordUploadError = { title: 'Upload failed', description: response?.message || 'The file could not be read.' };
            }
          }
          this.cdRef.detectChanges();
        },
        error: (err) => {
          console.error(`${documentType} upload failed:`, err);
          if (documentType === 'prompts') {
            this.promptSampleFile = null;
            this.promptUploadPercent = null;
          } else {
            this.keywordSampleFile = null;
            this.keywordUploadPercent = null;
          }
          this.cdRef.detectChanges();
        }
      });
  }

  downloadPromptSample(): void {
    this.downloadSample('prompts', 'Prompt_Template.xlsx');
  }

  downloadKeywordSample(): void {
    this.downloadSample('keywords', 'Keyword_Template.xlsx');
  }

  // Passes the template being generated for, so the API hands back the single-column sheet
  // rather than the Web Pages page-mapping workbook.
  private downloadSample(documentType: 'keywords' | 'prompts', fileName: string): void {
    this.campaignService.getSampleDocument(
      Number(this._storageHelper.user.bId),
      documentType,
      this.mwcModalData?.AIData?.templateId || 0
    ).pipe(take(1)).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => console.error(`Failed to download ${documentType} sample:`, err)
    });
  }

  discoverPrompts(): void {
    const description = (this.generateAiForm.get('description')?.value || '').trim();
    if (!description) {
      return;
    }

    this.generationInProgressHelperService.openWaitingPopup(null, 'Generation in Progress...');

    this.articleService.generatePromptRecommendations(description).subscribe(
      (response: any) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        const recommendations = this.parsePromptRecommendations(response);
        if (!recommendations || recommendations.length === 0) {
          this.articleHelperService.showErrorModal(
            this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL,
            new Error('No prompts were generated for the given topic. Please try again with a different topic.'));
          return;
        }

        const modalRef = this.modalService.create({
          mwcWidth: '1200px',
          mwcContent: SelectPromptsModalComponent,
          mwcData: {
            prompts: recommendations,
            existingPrompts: this.selectedPrompts
          },
          mwcCentered: true,
          mwcClassName: 'select-prompts'
        });
        modalRef.componentInstance.confirmEmitter.subscribe((res: string[]) => {
          const merged = [...this.selectedPrompts, ...res];
          this.selectedPrompts = merged.slice(0, this.maxPromptsAllowed);
          modalRef.close();
        });
      },
      (error: HttpErrorResponse) => {
        this.generationInProgressHelperService.closeTemplateSelector();
        this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error);
      }
    );
  }

  // Silent counterpart of discoverPrompts: no waiting popup, no selection modal and no error
  // modal - the top suggestions go straight into the list, and a failure just leaves it empty.
  // Skipped when prompts were already handed in, and it never overwrites prompts the user added
  // while the request was in flight.
  private prepopulatePrompts(topic: string): void {
    if (!this.hasKeywordPlanner || this.selectedPrompts.length > 0 || !topic?.trim()) {
      return;
    }
    this.isPromptsPrepopulating = true;
    this.articleService.generatePromptRecommendations(topic.trim())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          this.isPromptsPrepopulating = false;
          if (this.selectedPrompts.length === 0) {
            this.selectedPrompts = this.parsePromptRecommendations(response).slice(0, this.maxPromptsAllowed);
          }
          this.cdRef.detectChanges();
        },
        error: (err) => {
          console.error('Prompt prepopulation failed:', err);
          this.isPromptsPrepopulating = false;
          this.cdRef.detectChanges();
        }
      });
  }

  private parsePromptRecommendations(response: any): string[] {
    const contents = response?.promptResponse?.contents;
    if (!contents || contents.length === 0) {
      return [];
    }
    const raw = (contents[0].content || '').replace(/```json/gi, '').replace(/```/g, '').trim();
    if (!raw) {
      return [];
    }

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.filter((p: any) => typeof p === 'string' && p.trim().length > 0);
      }
      if (parsed && Array.isArray(parsed.Prompts)) {
        return parsed.Prompts.filter((p: any) => typeof p === 'string' && p.trim().length > 0);
      }
    } catch {
      // fall through to lenient parser
    }

    const arrayMatch = raw.match(/"Prompts"\s*:\s*\[([\s\S]*?)\]/);
    const inner = arrayMatch ? arrayMatch[1] : raw;
    return inner
      .split(/"\s*,\s*\n+/)
      .map(part => part
        .replace(/^[\s,]*"/, '')
        .replace(/"\s*$/, '')
        .replace(/\\"/g, '"')
        .trim())
      .filter(p => p.length > 0);
  }

  selectYourKeywordModal(isLoading, spinner, resetCount): void {
    this.tracking.trackEvent(
      'pageview', 'Generic Flow - Proceed to Keyword Selection'
    );
    // call ai generation loading modal here 
    if (resetCount) {
      this.retryCount = 0;
    }
    if (!isLoading) {
      this.generationInProgressHelperService.openWaitingPopup(null, 'Generation in Progress...');
      //spinner = this.articleHelperService.showAiGenerationLoadingModal(this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL);
      //this.isLoading = true;
    }
    try {
      let tagTone = this.generateAiForm.get("tone").value;
      let language = this.provinceData.find((ele, index) => ele.value == this.generateAiForm.get("language").value).label;
      let aiEngine = this.generateAiForm.get("aiEngine").value;
      // call an api to extract keyphrases
      this.articleService.generateKeyphrasesFromContext(this.generateAiForm.get("description").value, tagTone, language, aiEngine).subscribe((aiResponse: any) => {
        try {
          if (!aiResponse.keyphraseResponse.contents && aiResponse.keyphraseResponse.errorCode > 0) {
            throw new Error(JSON.stringify(aiResponse.keyphraseResponse.errorMessage));
          }
          // Modify the string to make it valid JSON - it will add double quotes to key 
          const validJSON = aiResponse.keyphraseResponse.contents[0].content.replace(/([a-zA-Z0-9_]+?):/g, '"$1":');
          const parsedObject = JSON.parse(validJSON);
          // call google keyword planner api to fetch keywords
          this.getKeyphraseFromGoogleKeywordsPlanner(parsedObject.Keyphrases, spinner);
        } catch (error) {
          //spinner.close();
          this.generationInProgressHelperService.closeTemplateSelector();

          this.isLoading = false;
          console.log(error);
          // this.msg.error(error, { mwcAnimate: true, mwcDuration: 10000 });
          // show error modal if kyephrase generation is failed
          this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error)
        }
      }, (error: HttpErrorResponse) => {
        //spinner.close();
        this.generationInProgressHelperService.closeTemplateSelector();
        this.isLoading = false;
        console.log(error);
        // this.msg.error(error.message, { mwcAnimate: true, mwcDuration: 10000 });
        // show error modal if kyephrase generation is failed
        this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error)
      })
    } catch (error) {
      //spinner.close();
      this.generationInProgressHelperService.closeTemplateSelector();
      this.isLoading = false;
      console.log(error);
      // this.msg.error(error, { mwcAnimate: true, mwcDuration: 10000 });
      // show error modal if kyephrase generation is failed
      this.articleHelperService.showErrorModal(this.modalService, this.modal, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error)
    }
  }



  // Failsafe keywords are only phrases - wrapped in the planner's shape with no metrics so the
  // selection modal renders them through the regular flow.
  private toKeywordPlannerShape(keyphrases: string[]): GoogleKeywordPlannerResponseType {
    const results = (keyphrases ?? []).map(text => ({
      text: text,
      keywordIdeaMetrics: null,
      keywordAnnotations: {},
      closeVariants: []
    }));
    return { results: results, nextPageToken: '', totalSize: String(results.length) } as GoogleKeywordPlannerResponseType;
  }

  // max_tokens can cut the fallback JSON off mid-array, so the payload arrives unparseable even
  // though every entry before the cut is intact. Parse normally, and only if that fails fall back
  // to lifting the complete quoted entries out of the Keyphrases array.
  private parseFailsafeKeyphrases(content: Content): string[] {
    const raw = content?.content ?? "";
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.Keyphrases?.length > 0) {
        return parsed.Keyphrases;
      }
    } catch {
      // Truncated or malformed - salvage below.
    }
    const keyIndex = raw.indexOf('"Keyphrases"');
    const arrayStart = keyIndex < 0 ? -1 : raw.indexOf("[", keyIndex);
    if (arrayStart < 0) {
      return [];
    }
    const entries: string[] = [];
    for (const match of raw.slice(arrayStart).match(/"[^"]*"/g) ?? []) {
      try {
        const value = JSON.parse(match);
        if (typeof value === "string" && value.trim().length > 0) {
          entries.push(value);
        }
      } catch {
        // Truncation can leave a final entry unparseable - skip it.
      }
    }
    return entries;
  }

  private handleFailsafeFailure(error: any, customError: CustomArticleErrorModel): void {
    this.generationInProgressHelperService.closeTemplateSelector();
    this.isLoading = false;
    console.log(error);
    this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error, customError);
  }

  // The profile's assigned users come from Midgard; the signed-in user's own name comes from
  // UserInfo instead, so this list does not have to contain them.
  private loadProfileAuthors(): void {
    this.articleService.getProfileAssignedUsers(this._storageHelper.user.pId)
      .subscribe((response: FindAssignedUsersResponse) => {
        if (!response?.users) {
          return;
        }
        const names = response.users
          .filter((user: AssignedUser) => !user.isDeactivated)
          .map((user: AssignedUser) => this.toAuthorName(user))
          .filter(name => name.length > 0);
        this.authorOptions = names.filter((name, index, all) => all.indexOf(name) === index);

        // UserInfo can resolve either side of this call, so re-apply rather than assume order.
        this.applyLoggedInAuthor();

        const selected = (this.authorNamePlaceholder ?? '').trim();
        if (selected.length === 0) {
          this.authorNamePlaceholder = this.loggedInAuthorName;
        } else {
          this.ensureAuthorOption(selected);
        }
        this.cdRef.detectChanges();
      });
  }

  // The signed-in user always heads the dropdown and is the default selection, whether or not
  // Midgard lists them among the profile's assigned users. Runs from both the UserInfo
  // subscription and the assigned-users response, since either can resolve first.
  private applyLoggedInAuthor(): void {
    const name = (this.loggedInAuthorName ?? '').trim();
    if (name.length === 0) {
      return;
    }
    this.authorOptions = [name, ...this.authorOptions.filter(option => option !== name)];

    const selected = (this.authorNamePlaceholder ?? '').trim();
    if (selected.length === 0) {
      this.authorNamePlaceholder = name;
    }
    this.cdRef.detectChanges();
  }

  // Midgard returns the name in parts; fall back to the login fields so a user with no first or
  // last name still appears rather than dropping out of the list.
  private toAuthorName(user: AssignedUser): string {
    if (!user) {
      return '';
    }
    const fullName = [user.firstName, user.lastName]
      .map(part => (part ?? '').trim())
      .filter(part => part.length > 0)
      .join(' ');
    return (fullName || user.userName || user.email || '').trim();
  }

  private ensureAuthorOption(name: string): void {
    const trimmed = (name ?? '').trim();
    if (trimmed.length > 0 && !this.authorOptions.includes(trimmed)) {
      this.authorOptions.push(trimmed);
    }
  }

  openManualAuthorPanel(): void {
    this.manualAuthorName = '';
    this.showManualAuthorPanel = true;
  }

  cancelManualAuthor(): void {
    this.showManualAuthorPanel = false;
    this.manualAuthorName = '';
  }

  // A manually added author joins the dropdown and becomes the selection, so it behaves
  // identically to a profile user from here on.
  addManualAuthor(): void {
    const name = (this.manualAuthorName ?? '').trim();
    if (name.length === 0) {
      return;
    }
    this.ensureAuthorOption(name);
    this.authorNamePlaceholder = name;
    this.cancelManualAuthor();
  }

  private openKeywordSelectionModal(keywordResponse: GoogleKeywordPlannerResponseType, tagTone: string,
    language: string, isFailsafe: boolean): void {
    const modalRef = this.modalService.create({
      mwcWidth: '1200px',
      mwcContent: SelectYourKeywordComponent,
      mwcData: {
        inputContext: this.generateAiForm.get("description").value,
        keywordResponse,
        tagTone: tagTone,
        language: language,
        aiEngine: this.generateAiForm.get("aiEngine").value,
        keywords: this.selectedKeywords,
        maxKeywords: this.maxKeywordsAllowed,
        isFailsafe: isFailsafe
      },
      mwcCentered: true,
      mwcClassName: 'select-keyword'
    });
    // An empty selection is valid - nothing is added to the keywords field.
    modalRef.componentInstance.confirmEmitter.subscribe(res => {
      this.selectedKeywords = Array.from(new Set([...this.selectedKeywords, ...(res ?? [])]));
      modalRef.close();
      this.cdRef.detectChanges();
    });
  }

  public getKeyphraseFromGoogleKeywordsPlanner(keyphrase: string, spinner: any): void {
    const customError: CustomArticleErrorModel = {
      ErrorHeading: $localize`:@@bs-create-new-modal-gkp-error-heading-text:Please Review Your Topic Name`,
      ErrorSubHeading: $localize`:@@bs-create-new-modal-gkp-error-subheading-text:We couldn’t find any relevant keyphrases or keywords based on the topic you entered. Try using a different topic or consider breaking it down into simpler terms.`
    }
    let tagTone = this.generateAiForm.get("tone").value;
    let language = this.provinceData.find((ele, index) => ele.value == this.generateAiForm.get("language").value).label;
    let aiEngine = this.generateAiForm.get("aiEngine").value;
    this.articleService.getKeyphraseFromGoogleKeywordsPlanner(keyphrase).subscribe((keywordResponse: GoogleKeywordPlannerResponseType) => {
      try {
        //this.modal.destroy();
        if (keywordResponse.results == null || keywordResponse.results.length <= 1) {
          this.articleService.generateKeyphrasesFromAIFallbackContext(this.generateAiForm.get("description").value, tagTone, language, aiEngine).subscribe((aiResponse: any) => {
            try {
              if (!aiResponse.keyphraseResponse.contents && aiResponse.keyphraseResponse.errorCode > 0) {
                throw new Error(JSON.stringify(aiResponse.keyphraseResponse.errorMessage));
              }
              // The server attaches planner metrics where Google has them; if it could not parse the
              // payload, salvage the keyphrases here and show them without metrics.
              const keywordResponse: GoogleKeywordPlannerResponseType = aiResponse.keywordResponse?.results?.length > 0
                ? aiResponse.keywordResponse
                : this.toKeywordPlannerShape(this.parseFailsafeKeyphrases(aiResponse.keyphraseResponse.contents[0]));
              if (keywordResponse.results.length <= 0) {
                throw new Error("Keywords not found for keyphrase");
              }
              // Offered for selection rather than appended; nothing is added unless the user applies a selection.
              this.isLoading = false;
              this.generationInProgressHelperService.closeTemplateSelector();
              this.openKeywordSelectionModal(keywordResponse, tagTone, language, true);
            } catch (error) {
              this.handleFailsafeFailure(error, customError);
            }
          }, (error: HttpErrorResponse) => {
            this.handleFailsafeFailure(error, customError);
          });
          return;
        }
        this.isLoading = false;
        //spinner.close();
        this.generationInProgressHelperService.closeTemplateSelector();
        this.openKeywordSelectionModal(keywordResponse, tagTone, language, false);
        this.retryCount = 0;
      } catch (error) {
        if (this.retryCount < this.maxRetryCount) {
          this.retryCount++;
          this.selectYourKeywordModal(true, spinner, false);
        }
        else {
          //spinner.close();
          this.generationInProgressHelperService.closeTemplateSelector();
          this.isLoading = false;
          console.log(error);
          // this.msg.error(error, { mwcAnimate: true, mwcDuration: 10000 });
          // show error modal if kyephrase generation is failed
          this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error, customError)
        }
      }
    }, (error: HttpErrorResponse) => {
      if (this.retryCount < this.maxRetryCount) {
        this.retryCount++;
        this.selectYourKeywordModal(true, spinner, false);
      }
      else {
        spinner.close();
        this.isLoading = false;
        console.log(error);
        // this.msg.error(error, { mwcAnimate: true, mwcDuration: 10000 });
        // show error modal if kyephrase generation is failed
        this.articleHelperService.showErrorModal(this.modalService, null, ErrorModalOrigins.FROM_KEYPHRASE_GENERATION_MODAL, error, customError)
      }
    });
  }

  onAddPersona(value: boolean) {
    this.personaEnabled = value;
  }

  onSavePersona(value: boolean) {
    this.tracking.trackEvent(
      'pageview', 'Custom Persona Added'
    );
    this.personaEnabled = value;
    if (this.addedPersona) {
      let updateAudienceRequest = new UpdateAudienceRequest();
      updateAudienceRequest.profileId = this._storageHelper.user.pId;
      updateAudienceRequest.audienceName = this.addedPersona;
      this.settingsService.updateAudience(updateAudienceRequest).subscribe((response: GetAudiencesResponseType) => {
        if (response.audiences && response.audiences.length > 0) {
          response.audiences.forEach(element => {
            this.interestsPersonalsList.push({
              label: element,
              value: element
            });
          });
          this.cdRef.detectChanges();
        }
      });
    }
    this.addedPersona = '';
  }

  noTilde(s) {
    if (s.normalize != undefined) {
      s = s.normalize("NFKD");
    }
    return s.replace(/[\u0300-\u036F]/g, "");
  }

  languageChanged(lang) {
    this.tracking.trackEvent(
      'pageview', 'Selection: Language'
    );
  }

  toneChanged(tone) {
    this.tracking.trackEvent(
      'pageview', 'Selection: Tone'
    );
  }
  public openPromptRepository() {
    window.open("https://support.milestoneinternet.com/en/support/solutions/folders/158001058708", "_blank");
  }

  //UpdateTextByContent(contentTitle: string): { titleText: string, placeholderText: string, contentBriefText: string } {
  //  var titleText = "";
  //  var placeholderText = "";
  //  var contentBriefText = "";
  //  switch (contentTitle) {
  //    case "Blog Article":
  //    case "HowTo Post":
  //    case "Listicle":
  //    case "Press Release":
  //    case "News Article":        
  //    case "NewsLetter":      
  //    case "Facebook Post":
  //    case "LinkedIn Post":
  //    case "Instagram Captions":
  //    case "Twitter Post":
  //    case "Google GMB Post":
  //    case "Apple Post":
  //    case "HowTo Video Script":
  //    case "Video Ideas":
  //    case "Podcast Script":
  //    case "Webinar Script":
  //       titleText = "What is the topic of your " + contentTitle;
  //       placeholderText = "Enter the topic of your " + contentTitle;
  //      switch (contentTitle) {
  //        case "Blog Article":
  //        case "HowTo Post":
  //        case "Listicle":
  //        case "Facebook Post":
  //        case "LinkedIn Post":
  //        case "Instagram Captions":
  //        case "Twitter Post":
  //        case "Google GMB Post":
  //        case "Apple Post":
  //        case "Press Release":
  //          contentBriefText = "Do you have a content brief";
  //          break;
  //        case "News Article":
  //        case "NewsLetter":
  //          contentBriefText = "Objective of the " + contentTitle;
  //          break;
  //        case "HowTo Video Script":
  //        case "Video Ideas":
  //          contentBriefText = "Do you have a Video Information Details";
  //          break;
  //        case "Podcast Script":
  //          contentBriefText = "Do you have a Podcast Objective";
  //          break;
  //        case "Webinar Script":
  //          contentBriefText = "Do you have a Webinar Objective";
  //          break;
  //        default:
  //          contentBriefText = "Do you have a content brief";
  //          break;
  //      }         
  //       return { titleText, placeholderText, contentBriefText };
  //      break;
  //    case "Quora Answers":
  //      titleText = "What is the question asked";
  //      placeholderText = "Enter the question to be asked ";
  //      contentBriefText = "What is the objective of the answer you want to include";
  //      return { titleText, placeholderText, contentBriefText };
  //      break;
  //    case "Search Ads":
  //    case "Display Ads":
  //    case "Email Sales Pitch":
  //      titleText = "What is the product / service you need to advertise";
  //      placeholderText = "Enter the product / service you need to advertise";
  //      contentBriefText = "Provide product / service features to showcase";
  //      return { titleText, placeholderText, contentBriefText };
  //      break;
  //    default:
  //       titleText = "What is the topic of your " + contentTitle;
  //       placeholderText = "Enter the topic of your " + contentTitle;
  //       contentBriefText = "Do you have a content brief";
  //      return { titleText, placeholderText, contentBriefText };
  //      break;
  //  }
  //}
  createBrandVoice() {
    this.isNoCreateBrandVoice = false;
    window.open(this.brandVoiceUrl + this._storageHelper.user.bId);
  }
  toggleContent() {
    this.isExpanded = !this.isExpanded;
    this.updateTextareaScroll();
  }

  private updateTextareaScroll() {
    const textarea = this.contentTextarea?.nativeElement;
    if (textarea != undefined) {
      if (!this.isExpanded) {
        textarea.scrollTo({ top: 0, behavior: 'smooth' });
        textarea.style.overflow = 'hidden';
      } else {
        textarea.style.overflow = 'auto';
      }
    }
  }
  brandVoiceChange(event) {
    console.log(event)
    this.tracking.trackEvent(
      'pageview', 'Brand Voice Dropdown Selection'
    );
    let data = this.brandVoiceList.filter(item => { if (item.value == event) return item })[0];
    if (data != null && data != undefined) {
      this.brandVoiceDetails = data;
      this.generateAiForm.patchValue(
        {
          brandVoiceDocument: data.brandVoiceDocument,
          brandVoiceDetails: data.details,
          brandVoiceId: +data.value
        }
      );
    }
  }

  createTargetAudience() {
    this.isNoTargetAudience = false;
    window.open(this.targetAudienceUrl + this._storageHelper.user.bId);
  }
  targetAudienceChange(event) {
    this.tracking.trackEvent(
      'pageview', 'Target Audience Dropdown Selection'
    );
    let data = this.targetAudienceList.filter(item => { if (item.title == event) return item })[0];
    if (data != null && data != undefined) {
      this.targetAudienceDetails = data;
      this.generateAiForm.patchValue(
        {
          targetAudienceDetails: data.thingTargetAudience.thingJson,
          targetAudienceId: +data.targetAudienceId
        }
      );
    }
  }
  getDaysDifference(inputDate) {
    // Convert input date to a Date object
    const date = new Date(inputDate);
    // Get today's date
    const today = new Date();

    // Reset time components to compare only dates
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    // Calculate difference in milliseconds
    const timeDifference = Math.abs(today.getTime() - date.getTime());

    // Convert milliseconds to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    // Format the result
    if (daysDifference === 0) {
      return "Today";
    } else if (daysDifference === 1) {
      return "1 day ago";
    } else {
      return `${daysDifference} days ago`;
    }
  }
  ageMapObject(value) {
    let foundObject = ageList.find(obj => obj.value === value)
    if (foundObject)
      return foundObject.label;
    else
      return null;
  }
  openRedirectToMPC(event) {
    // Target the settings BV/TA routes; the bare /target-audience and /brand-voice routes
    // fell through to the dashboard redirect.
    if (event == 'targetAudience') {
      const route = this.router.createUrlTree(['/settings/target-audience']);
      const url = this.router.serializeUrl(route);
      window.open(url, '_blank');
    } else if (event == 'knowledgeVault') {
      const route = this.router.createUrlTree(['/settings/knowledge-vault']);
      const url = this.router.serializeUrl(route);
      window.open(url, '_blank');
    } else {
      const route = this.router.createUrlTree(['/settings/brand-voice']);
      const url = this.router.serializeUrl(route);
      window.open(url, '_blank');
    }
    //this.newTemplateHelperService.closeTemplateSelector();
    //this.modal.destroy();
  }

  reloadList(event: string) {
    if (event == "targetAudience") {
      this.fetchTargetAudiences(true);
    } else {
      this.fetchBrandVoices(true);
    }
  }
  redirectToMPCModalCancel(): void {
    this.isRedirectToMPC = false;
  }
  redirectToMPCModalOk(): void {
    this.isRedirectToMPC = false;
    if (this.modalType == 'targetAudience') {
      window.open(this.targetAudienceUrl + this._storageHelper.user.bId);
    } else {
      window.open(this.brandVoiceUrl + this._storageHelper.user.bId);
    }
  }

  openCustomerPortal(actionType: string) {
    this.commonService.openCustomerPortal(actionType).subscribe(
      (stripeUrl: string) => {
        if (stripeUrl) {
          window.location.href = stripeUrl;
        }
      },
      (error) => {
        console.error('Error occurred:', error);
        window.location.href = this._storageHelper.user.returnUrl + this._storageHelper.user.businessInformationUrl + this._storageHelper.user.bId;
      }
    );
  }

  //Stepper sidebar - same disable rule the native tabset tab uses, extracted so both can share it
  isTabDisabled(tab: any): boolean {
    if ((this.isAnalyzeandProceed && tab.name != 'Analysis' && tab.name != 'Creation Flow' && !this.isRegenerateFlow) || (tab.name == 'Analysis' && this.isRegenerateFlow)) {
      return true;
    }
    // Can't jump ahead of Topic Details via the sidebar until it's actually filled in -
    // same completion rule the footer's Continue/Generate buttons already enforce.
    const topicDetailsTab = this.tabs.find((t: any) => t.name === 'Topic Details');
    if (topicDetailsTab && tab.index > topicDetailsTab.index && !this.hasDescription) {
      return true;
    }
    return false;
  }

  //Stepper sidebar - replicates exactly what clicking the native (now visually hidden) tab header does
  selectStep(tab: any): void {
    if (this.isTabDisabled(tab)) {
      return;
    }
    this.tabSelectChange(['click', tab]);
    this.selectedIndex = tab.index;
    this.tabsSetSelectChange([tab.index]);
    this.triggerOutlineGenerationIfNeeded();
  }

  goBack(): void {
    if (this.selectedIndex > 0) {
      this.selectedIndex = this.selectedIndex - 1;
    }
  }

  //
  tabsSetSelectChange(args: any[]): void {
    //console.log(args);
    if (this.selectedIndex == (this.tabs.length - 1) && this.isRegenerateFlow) {
      this.regenerateFlowButtonText = "Regenerate";
      this.cdRef.detectChanges();
    }
  }
  tabSelectChange(args: any[]): void {
    console.log(args);
    this.isShowDetailsBV = false;
    this.isShowDetailsTA = false;
    if (args[1].name == 'Content Brief' && this.clickCount == 0) {
      this.clickCount += 1;
      this.generateQuestionFromAI();
    }

    this.contentAnalysisReset();
  }
  selectBV(value) {
    this.selectedBrandVoice = value;
    this.brandVoiceChange(value);
    this.isShowDetailsBV = true;
    let data = this.filteredBrandVoiceList.filter(item => { if (item.value == value) return item })[0];
    if (data != null && data != undefined) {
      if (data.isDefault) {
        this.isDefaultBVAvailable = true;
      }
      else {
        this.isDefaultBVAvailable = false;
      }
    }
  }
  processAction() {
    if (this.selectedIndex == 0 && this.clickCount == 0) {
      this.clickCount += 1;
      this.generateQuestionFromAI();
    }
    this.selectedIndex = this.selectedIndex + 1;
    this.triggerOutlineGenerationIfNeeded();
  }

  //Kicks off outline generation the first time the Content Outline step is reached,
  //regardless of whether it was reached via the footer button or a direct sidebar click.
  private triggerOutlineGenerationIfNeeded(): void {
    if (this.tabs[this.selectedIndex]?.name === 'Content Outline' && !this.outlineGenerated && !this.isGeneratingOutline) {
      this.generateOutline();
    }
  }

  // Whether this template gets a Content Outline step. Drives both whether the tab is built and
  // whether an approved outline is sent with the generation, so the two can never disagree.
  get isContentOutlineAvailable(): boolean {
    return this.outlineEnabledTemplateIds.includes(Number(this.selectedTemplateId));
  }

  // Everything the Topic Details, Content Brief and Preferences steps collected, in the shape the
  // outline endpoint expects. Kept separate from the request so a regenerate rebuilds it from
  // whatever is on the form now, rather than replaying what the first attempt happened to send.
  private buildOutlinePayload(): TopicIdeaPayloadForAIGeneration {
    const language = this.provinceData.find(p => p.value == this.generateAiForm.controls['language'].value)?.label || this.generateAiForm.controls['language'].value;
    const payload = new TopicIdeaPayloadForAIGeneration();

    // Topic Details
    payload.topicIdea = this.mwcModalData.AIData.topicIdea;
    payload.topicIdea.language = this.generateAiForm.controls['language'].value || '';
    payload.topicIdea.pillarIdea = this.generateAiForm.controls['description'].value || '';
    payload.topicIdea.coreTopic = this.generateAiForm.controls['coreTopic'].value || '';
    payload.topicIdea.keywords = this.selectedKeywords;
    payload.prompts = this.selectedPrompts ? [...this.selectedPrompts] : [];

    // Content Brief - the answers plus the questions they belong to, so the prompt can pair them up
    payload.contentBrief = this.buildContentBriefAnswers();
    payload.contentBriefQuestions = this.getContentBriefQuestions();

    // Preferences
    payload.tone = this.generateAiForm.controls['tone'].value;
    payload.language = language;
    payload.projectType = this.generateAiForm.controls['projectType'].value;
    payload.contentOutlineGoal = this.selectedGoalDetail?.title || '';
    payload.intent = this.selectedGoalDetail?.title;
    payload.wordCount = +this.wordCountPlaceholder;
    payload.isInternalLinksEnable = this.isInternalLinksEnable;
    payload.gender = this.generateAiForm.controls['gender'].value;
    payload.ageGroup = this.generateAiForm.controls['ageGroup'].value;
    payload.interestAndPersona = this.generateAiForm.controls['interestsPersonals'].value;
    payload.brandVoiceId = this.generateAiForm.controls['brandVoiceId'].value;
    payload.brandVoiceDocument = this.generateAiForm.controls['brandVoiceDocument'].value;
    payload.brandVoiceDetails = this.generateAiForm.controls['brandVoiceDetails'].value;
    payload.targetAudienceId = this.generateAiForm.controls['targetAudienceId'].value;
    payload.targetAudienceDetails = this.generateAiForm.controls['targetAudienceDetails'].value;
    payload.knowledgeChunkData = this.KnowledgeVaultChunkData;
    payload.isKnowledgeVaultEnable = this.isKnowledgeVaultEnable;

    payload.templateId = this.selectedTemplateId;
    payload.templateTitle = this.selectedTemplateTitle;
    payload.isGenericFlow = this.isGenericFlow;

    return payload;
  }

  // The Content Brief answers as one "$$" joined string. Which trio of controls holds them depends
  // on whether the step managed to ask AI generated questions or fell back to its static ones.
  private buildContentBriefAnswers(): string {
    const answerFor = (control: string) => this.generateAiForm.controls[control]?.value || '';
    return this.isQuestionExist
      ? [answerFor('AnswerAI0'), answerFor('AnswerAI1'), answerFor('AnswerAI2')].join('$$')
      : [answerFor('FirstAnswer'), answerFor('SecondAnswer'), answerFor('ThirdAnswer')].join('$$');
  }

  // The questions those answers were given to, so the prompt can pair them up. The AI generated
  // set when the step managed to ask them, otherwise the three static questions the Content Brief
  // template renders - kept in step with the #elseBlock in genarate-ai.component.html.
  private getContentBriefQuestions(): string[] {
    if (this.isQuestionExist) {
      return this.questionsFromAI ? [...this.questionsFromAI] : [];
    }
    return [
      `What do you want the reader to know about ${this.inputText}?`,
      `What facts do you want to convey about ${this.inputText}?`,
      'Do you want to include any additional information for reference?'
    ];
  }

  generateOutline(): void {
    if (this.isGeneratingOutline) {
      return;
    }
    this.isGeneratingOutline = true;
    this.outlineGenerated = false;
    this.outlineError = '';
    this.startOutlineTipRotation();
    this.cdRef.detectChanges();

    this.articleService.generateContentOutline(this.buildOutlinePayload()).subscribe({
      next: (response: GenerateContentOutlineResponse) => {
        this.applyGeneratedOutline(response);
      },
      error: (err) => {
        console.error('GenerateContentOutline error:', err);
        this.failOutlineGeneration('We could not generate an outline just now. Please try again.');
      }
    });
  }

  regenerateOutline(): void {
    this.generateOutline();
  }

  private applyGeneratedOutline(response: GenerateContentOutlineResponse): void {
    // Only the headings are shown and edited; purpose, key points, format and word budget are
    // kept on each section so they can be handed to the article generation afterwards.
    const sections: ContentOutlineSection[] = (response?.sections || [])
      .map(section => ({
        header: (section?.header || '').trim(),
        purpose: section?.purpose,
        keyPoints: section?.keyPoints || [],
        recommendedFormat: section?.recommendedFormat,
        estimatedWordCount: section?.estimatedWordCount,
        subheadings: (section?.subheadings || [])
          .map(subheading => ({
            header: (subheading?.header || '').trim(),
            keyPoints: subheading?.keyPoints || [],
            recommendedFormat: subheading?.recommendedFormat,
            estimatedWordCount: subheading?.estimatedWordCount
          }))
          .filter(subheading => !!subheading.header)
      }))
      .filter(section => !!section.header);

    // An empty outline is a failed generation, not a blank canvas - saying so beats handing back a
    // single empty card that looks like the model had nothing to suggest.
    if (sections.length === 0) {
      this.failOutlineGeneration(response?.errorMessage || 'We could not generate an outline just now. Please try again.');
      return;
    }

    this.stopOutlineTipRotation();
    this.isGeneratingOutline = false;
    this.outlineGenerated = true;
    this.outlineError = '';
    this.outlineSections = sections;
    this.outlineTitle = response?.title || '';
    this.outlinePurpose = response?.purpose || '';
    this.outlineFormat = response?.recommendedFormat || '';
    this.cdRef.detectChanges();
  }

  private failOutlineGeneration(message: string): void {
    this.stopOutlineTipRotation();
    this.isGeneratingOutline = false;
    this.outlineGenerated = false;
    this.outlineSections = [];
    this.outlineTitle = '';
    this.outlinePurpose = '';
    this.outlineFormat = '';
    this.outlineError = message;
    this.cdRef.detectChanges();
  }

  // Leaves the failed state behind and opens an empty outline for the user to write themselves,
  // so a generation that will not come back is not a dead end.
  startOutlineFromScratch(): void {
    this.outlineError = '';
    this.outlineGenerated = true;
    this.outlineSections = [this.createOutlineSection()];
    this.cdRef.detectChanges();
  }

  // A section the user added by hand. It carries no plan of its own, so the article generation is
  // told only its heading and picks the format for it.
  private createOutlineSection(): ContentOutlineSection {
    return { header: '', keyPoints: [], subheadings: [] };
  }

  // The outline as the user left it, blank rows dropped. Sent with the final generation so the
  // article follows the approved plan; an outline edited down to nothing sends nothing.
  // The template is re-checked here because Select Templates can switch it after the outline was
  // built, and a plan for a Blog has no business steering a template that never showed the step.
  private getApprovedOutline(): ContentOutlineSection[] {
    if (!this.outlineGenerated || !this.isContentOutlineAvailable) {
      return [];
    }
    return this.outlineSections
      .map(section => ({
        ...section,
        header: (section.header || '').trim(),
        subheadings: (section.subheadings || [])
          .map(subheading => ({ ...subheading, header: (subheading.header || '').trim() }))
          .filter(subheading => !!subheading.header)
      }))
      .filter(section => !!section.header);
  }

  private startOutlineTipRotation(): void {
    this.outlineTips = this.generationInProgressHelperService.seoAnalysisListReturn();
    this.activeOutlineTipIndex = 0;
    this.stopOutlineTipRotation();
    this.outlineTipInterval = setInterval(() => {
      this.activeOutlineTipIndex = (this.activeOutlineTipIndex + 1) % this.outlineTips.length;
      this.cdRef.detectChanges();
    }, 4000);
  }

  private stopOutlineTipRotation(): void {
    if (this.outlineTipInterval) {
      clearInterval(this.outlineTipInterval);
      this.outlineTipInterval = null;
    }
  }

  onOutlineSectionDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    moveItemInArray(this.outlineSections, event.previousIndex, event.currentIndex);
    this.cdRef.detectChanges();
  }

  addOutlineSection(): void {
    this.outlineSections.push(this.createOutlineSection());
  }

  removeOutlineSection(index: number): void {
    this.outlineSections.splice(index, 1);
  }

  addOutlineSubheading(sectionIndex: number): void {
    this.outlineSections[sectionIndex].subheadings.push({ header: '', keyPoints: [] });
  }

  removeOutlineSubheading(sectionIndex: number, subheadingIndex: number): void {
    this.outlineSections[sectionIndex].subheadings.splice(subheadingIndex, 1);
  }

  isDeleteOutlineSectionModalVisible: boolean = false;
  private outlineSectionIndexToDelete: number | null = null;

  openDeleteOutlineSectionModal(index: number): void {
    this.outlineSectionIndexToDelete = index;
    this.isDeleteOutlineSectionModalVisible = true;
  }

  cancelDeleteOutlineSection(): void {
    this.isDeleteOutlineSectionModalVisible = false;
    this.outlineSectionIndexToDelete = null;
  }

  confirmDeleteOutlineSection(): void {
    if (this.outlineSectionIndexToDelete !== null) {
      this.removeOutlineSection(this.outlineSectionIndexToDelete);
    }
    this.isDeleteOutlineSectionModalVisible = false;
    this.outlineSectionIndexToDelete = null;
  }

  isDeleteOutlineSubheadingModalVisible: boolean = false;
  private outlineSubheadingToDelete: { sectionIndex: number; subheadingIndex: number } | null = null;

  openDeleteOutlineSubheadingModal(sectionIndex: number, subheadingIndex: number): void {
    this.outlineSubheadingToDelete = { sectionIndex, subheadingIndex };
    this.isDeleteOutlineSubheadingModalVisible = true;
  }

  cancelDeleteOutlineSubheading(): void {
    this.isDeleteOutlineSubheadingModalVisible = false;
    this.outlineSubheadingToDelete = null;
  }

  confirmDeleteOutlineSubheading(): void {
    if (this.outlineSubheadingToDelete) {
      const { sectionIndex, subheadingIndex } = this.outlineSubheadingToDelete;
      this.removeOutlineSubheading(sectionIndex, subheadingIndex);
    }
    this.isDeleteOutlineSubheadingModalVisible = false;
    this.outlineSubheadingToDelete = null;
  }

  ngOnDestroy(): void {
    this.stopOutlineTipRotation();
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  changeBV() {
    this.isShowDetailsBV = false;
  }
  viewAllTA() {
    this.isShowDetailsTA = false;
  }
  selectTV(value) {
    this.selectedTargetAudience = value;
    this.targetAudienceChange(this.selectedTargetAudience);
    this.isShowDetailsTA = true;
    let data = this.filteredTargetAudienceList.filter(item => { if (item.title == value) return item })[0];
    if (data != null && data != undefined) {
      if (data.isDefault) {
        this.isDefaultTAAvailable = true;
      }
      else {
        this.isDefaultTAAvailable = false;
      }
    }
  }
  closeModal() {
    this.articleHelperService.OpenTemplateChange.next(true);
    this.modal.close();
  }
  generateQuestionFromAI() {
    if (this.selectedTemplateTitle == 'Marketing Brief') {
      this.questionsFromAI = [
        "What is the problem to address and why should it be solved ?",
        "What is the main goal, KPI or challenge this marketing initiative should address ?",
        "What is the desired outcome of this brief ?"
      ];
      
      this.isQuestionExist = true;
      this.cdRef.detectChanges();
    } else {
      this.isLoading = true;
      let request = new GenerateQuestionsByAIRequest();
      request.coreTopic = this.generateAiForm.controls["coreTopic"].value ? this.generateAiForm.controls["coreTopic"].value : "";
      request.pillarData = this.generateAiForm.controls["description"].value ? this.generateAiForm.controls["description"].value : "";
      request.keywords = this.selectedKeywords;
      this.articleService.GenerateQuestionsByAI<GenerateQuestionsByAIResponse>(request)
        .subscribe((response: GenerateQuestionsByAIResponse) => {
          if (response != null && response.success) {
            this.questionsFromAI = response.questions;
            this.isQuestionExist = true;
          }
          // Reset on an unsuccessful response too, or the Generate button stays in its loading state.
          this.isLoading = false;
          this.cdRef.detectChanges();
        }, (error) => {
          this.isQuestionExist = false;
          this.cdRef.detectChanges();
          this.isLoading = false;
        });
    }
  }

  // -1 when nothing is refreshing. Tracked per index so only the question being regenerated shows a
  // spinner, and the other refresh buttons stay usable.
  refreshingQuestionIndex: number = -1;

  refreshQuestion(index: number) {
    if (this.refreshingQuestionIndex !== -1 || !this.questionsFromAI || !this.questionsFromAI[index]) {
      return;
    }

    this.refreshingQuestionIndex = index;
    this.cdRef.detectChanges();

    let request = new GenerateQuestionsByAIRequest();
    request.coreTopic = this.generateAiForm.controls["coreTopic"].value ? this.generateAiForm.controls["coreTopic"].value : "";
    request.pillarData = this.generateAiForm.controls["description"].value ? this.generateAiForm.controls["description"].value : "";
    request.keywords = this.selectedKeywords;
    request.questionCount = 1;
    // Send every question on screen so the replacement is not a reword of one already asked.
    request.existingQuestions = this.questionsFromAI;

    this.articleService.GenerateQuestionsByAI<GenerateQuestionsByAIResponse>(request)
      .subscribe((response: GenerateQuestionsByAIResponse) => {
        const question = response && response.success && response.questions ? response.questions[0] : null;
        if (question) {
          // Replace the array so the *ngFor picks the change up, and keep the answer already typed
          // against this question - only the wording is being regenerated.
          this.questionsFromAI = this.questionsFromAI.map((existing, i) => i === index ? question : existing);
        }
        this.refreshingQuestionIndex = -1;
        this.cdRef.detectChanges();
      }, (error) => {
        console.log(error);
        this.refreshingQuestionIndex = -1;
        this.errorMessage = "Could not regenerate the question, please try again.";
        this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'top', mwcClass: 'error-notification-content' });
        this.cdRef.detectChanges();
      });
  }

  triggerSearchBV() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchBrandVoice(this.searchTxt);
    }, 1000);
  }

  searchBrandVoice(searchText: string = "") {
    const query = searchText.toLowerCase();
    this.filteredBrandVoiceList = this.brandVoiceList.filter(s => s.tone.toLowerCase().includes(query) || s.label.toLowerCase().includes(query) || s.createdBy.toLowerCase().includes(query));
    if (this.filteredBrandVoiceList.length == 0) {
      this.FoundSerchBV = false;
      this.filteredBrandVoiceList = this.brandVoiceList;
    }
    else {
      this.FoundSerchBV = true;
      this.filteredBrandVoiceList = [...this.filteredBrandVoiceList];
    }
    this.cdRef.detectChanges();
  }

  triggerSearchTA() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchTargetAudience(this.searchTxt);
    }, 1000);
  }

  searchTargetAudience(searchText: string = "") {
    const query = searchText.toLowerCase();
    this.filteredTargetAudienceList = this.targetAudienceList.filter(s => {
      const titleMatch = s.title.toLowerCase().includes(query);
      const authorMatch = s.authorName.toLowerCase().includes(query);
      const genderMatch = s.thingTargetAudience?.thingJson?.gender?.some((g: string) =>
        g.toLowerCase().includes(query)
      );
      const ageGroupMatch = s.thingTargetAudience?.thingJson?.ageGroup?.some((ag: string) =>
        ag.toLowerCase().includes(query)
      );
      return titleMatch || authorMatch || genderMatch || ageGroupMatch;
    });
    this.FoundSearchTA = this.filteredTargetAudienceList.length > 0;
    if (!this.FoundSearchTA) {
      this.filteredTargetAudienceList = this.targetAudienceList;
    }
    this.cdRef.detectChanges();
  }

  SelectedTemplate(value) {
    let data = this.rowedData
      .map(innerArray =>
        innerArray.filter(obj => obj.templateId == value.templateId)
      )
      .filter(innerArray => innerArray.length > 0)[0][0];
    if (data != null && data != undefined) {
      this.rowedData = this.rowedData.map(innerArray =>
        innerArray.map(obj => ({
          ...obj,
          isSelected: obj.templateId === value.templateId ? true : false
        }))
      );
    }
  }


  SelectedBV(value) {
    let data = this.brandVoiceList.filter(item => { if (item.value == value) return item })[0];
    if (data != null && data != undefined) {
      this.filteredBrandVoiceList = [];
      this.brandVoiceList.forEach((brandVoice) => {
        if (brandVoice.value == value) {
          this.filteredBrandVoiceList.push({
            label: brandVoice.label, value: brandVoice.value, tone: brandVoice.tone, createdOn: brandVoice.createdOn, createdBy: brandVoice.createdBy, brandVoiceDocument: brandVoice.brandVoiceDocument, details: brandVoice.details, isDefault: true, isSelectedBV: true
          })
          this.isDefaultBVAvailable = true;
          this.selectedBrandVoice = value;
          this.brandVoiceDetails = data;
          this.generateAiForm.patchValue(
            {
              brandVoiceDocument: data.brandVoiceDocument,
              brandVoiceDetails: data.details,
              brandVoiceId: +data.value
            }
          );
        }
        else {
          this.filteredBrandVoiceList.push({
            label: brandVoice.label, value: brandVoice.value, tone: brandVoice.tone, createdOn: brandVoice.createdOn, createdBy: brandVoice.createdBy, brandVoiceDocument: brandVoice.brandVoiceDocument, details: brandVoice.details, isDefault: false, isSelectedBV: false
          })
        }
      });
    }
  }

  SelectedTA(value) {
    let data = this.targetAudienceList.filter(item => { if (item.title == value) return item })[0];
    if (data != null && data != undefined) {
      this.filteredTargetAudienceList = [];

      this.targetAudienceList.forEach((targetAudience) => {
        if (targetAudience.title == value) {
          this.filteredTargetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.thingTargetAudience.thingJson.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": true,
            "isSelectedTA": true
          });
          this.isDefaultTAAvailable = true;
          this.selectedTargetAudience = value;
          this.targetAudienceDetails = data;
          this.generateAiForm.patchValue(
            {
              targetAudienceDetails: data.thingTargetAudience.thingJson,
              targetAudienceId: +data.targetAudienceId
            }
          );
        }
        else {
          this.filteredTargetAudienceList.push({
            "targetAudienceId": targetAudience.targetAudienceId,
            "title": targetAudience.title,
            "authorName": targetAudience.authorName,
            "thingTargetAudience": {
              "thingJson": {
                "title": targetAudience.thingTargetAudience.thingJson.title,
                "gender": targetAudience.thingTargetAudience.thingJson.gender,
                "ageGroup": targetAudience.thingTargetAudience.thingJson.ageGroup,
                "relationshipStatus": targetAudience.thingTargetAudience.thingJson.relationshipStatus,
                "industry": targetAudience.thingTargetAudience.thingJson.industry,
                "interests": targetAudience.thingTargetAudience.thingJson.interests,
                "intent": targetAudience.thingTargetAudience.thingJson.intent
              }
            },
            "createdDate": targetAudience.createdDate,
            "isDefault": false,
            "isSelectedTA": false
          });
        }
      });
    }
  }

  //Template
  distributeToRows(data) {
    let distributed = [];
    let row = [];
    data.forEach((datum, i) => {
      if (i && i % 3 == 0) {
        distributed.push([...row]);
        row = [];
      }
      datum.isSelected = false;
      if (datum.title == "Blog Post") {
        datum.isSelected = true;
      }
      row.push(datum);
    });
    distributed.push([...row]);
    return distributed;
  }
  getAllTemplatesAndSettings() {
    let req = new GetAllTemplateRequest();
    req.IsForCampaign = false;
    const getTemplatesRequest = this.articleService.GetAllTemplate<GetAllTemplateResponse>(req);
    let getSettingsFileRequest = new GetSettingsFileRequest();
    getSettingsFileRequest.ProfileId = this._storageHelper.user.pId;
    const getSettingsRequest = this.settingsService.getSettings<GetSettingsFileRequest>(getSettingsFileRequest);
    forkJoin({
      templatesResponse: getTemplatesRequest,
      settingsResponse: getSettingsRequest
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ templatesResponse, settingsResponse }) => {
        if (templatesResponse) {
          this.AllTemplateResponse = templatesResponse;
          this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates];
          this.templatesCount['all'] = this.allTemplates.length;
          this.templateTypes.forEach(type => {
            this.templatesCount[type] = this.allTemplates.filter(t => t.type === type).length;
          });
          this.rowedData = this.distributeToRows([...this.allTemplates.filter(obj => obj.title !== "Content Repurpose" && obj.title !== "Blank Article"
            && obj.title !== "Bulk Meta Generator" && obj.title !== "Web Pages")]);
          this.rowedData = this.rowedData
            //.map(innerArray =>
            //  innerArray.filter(obj => obj.title !== "Content Repurpose" && obj.title !== "Blank Article")
            //)
            .filter(innerArray => innerArray.length > 0);
          this.fillSelectTemplatesList();
        }
        if (settingsResponse) {
          this.settings = settingsResponse;
        }
        this.cdRef.detectChanges();
      });
  }
  fillSelectTemplatesList() {
    this.templatesList = this.allTemplates
      .filter(t => t.templateId !== 0 && t.title !== "Content Repurpose" && t.title !== "Blank Article"
        && t.title !== "Bulk Meta Generator" && t.title !== "Web Pages")
      .map(t => ({ ...t, selected: t.templateId === this.selectedTemplateId }));
    this.filteredTemplatesList = this.templatesList;
  }

  triggerSearchTemplates() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchTemplate(this.searchTxtTemplates);
    }, 1000);
  }

  searchTemplate(searchText: string = "") {
    const query = searchText.toLowerCase();
    this.filteredTemplatesList = this.templatesList.filter(s => s.title.toLowerCase().includes(query));
    if (this.filteredTemplatesList.length == 0) {
      this.FoundSearchTemplates = false;
      this.filteredTemplatesList = this.templatesList;
    }
    else {
      this.FoundSearchTemplates = true;
      this.filteredTemplatesList = [...this.filteredTemplatesList];
    }
    this.cdRef.detectChanges();
  }

  changeFilterBy(value: string) {
    this.filterBy = value;
    if (this.filterBy === "recently-used") {
      this.filteredTemplatesList = this.templatesList.filter(t => t.recentlyUsed === true);
    }
    else if (this.filterBy === "alphabetical-order") {
      this.filteredTemplatesList = [...this.templatesList].sort((a, b) => a.title.localeCompare(b.title));
    }
    else {
      this.filteredTemplatesList = [...this.templatesList];
    }
    this.cdRef.detectChanges();
  }

  SelectTemplateForGeneration(template) {
    template.selected = !template.selected;
    this.cdRef.detectChanges();
  }

  viewDetailsEvent(data) {
    this.isViewDetails = true;
    this.viewData = data;
  }
  viewDetailsBackEvent() {
    this.isViewDetails = false;
  }
  FormattedText(whyUseText: string): string {
    const cleaned = whyUseText.replace(/\d/g, (match, offset, str) => {
      const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
      const before = str[offset - 1] || "";
      const after = str[offset + 1] || "";
      // Keep the digit if it's surrounded by '-' or '–'
      if ((before === "-" || before === "–" || (before!=""&& numbers.includes(+before))) || (after === "-" || after === "–" || (after!="" && numbers.includes(+after)))) {
        return match; // keep the digit
      }
      return ""; // otherwise remove the digit
    });
    const [boldPart, ...normalPart] = cleaned.replace(".", "").split(":");
    if (normalPart.length == 0) {
      return `${boldPart}`;
    }
    return `<strong>${boldPart}:</strong>${normalPart.join(":")}`;
  }
  initializeNewArticle(mode: string, templateData: Template) {
    this.tracking.trackEvent(
      'pageview', `Template - ${templateData.title}`
    );

    if (templateData.templateId === 0) {
      mode = 'mannual';
    }
    this.generateModalAIRef = this.articleHelperService.createnewpost(mode, this._router, this.modalService, this.settings, this.topicData, templateData, this.textTitle);
  }
  onSelect(card) {
    this.selectedCard = card;
  }
  AddOrRemoveAsFav(TemplateId: number) {
    let request = new AddOrRemoveAsFavoriteTemplateRequest();
    request.templateId = TemplateId;
    this.articleService.AddOrRemoveAsFavoriteTemplate<AddOrRemoveAsFavoriteTemplateResponse>(request)
      .subscribe((response: AddOrRemoveAsFavoriteTemplateResponse) => {
        if (response != null && response.errorCode == 0) {
          if (response.success) {
            this.getAllTemplatesAndSettings();
            this.isViewDetails = false;
          }
        }
        this.cdRef.detectChanges();
      }, (error) => {
        this.cdRef.detectChanges();
      });
  }

  //Upload
  fileList = [];
  @ViewChild('ErrorAlertTemplate') ErrorAlertTemplate!: TemplateRef<any>;

  isFileAnalysis: boolean = true;
  handleChange({ file, fileList }: MwcUploadChangeParam): void {
    console.log('in')
    const status = file.status;
    if (status !== 'uploading') {
      console.log(file, fileList);
    }
    if (status === 'done') {
      this.fileList = [{
        uid: '-xxx',
        percent: 100,
        name: file.name,
        status: 'done',
      }];
      //this.msg.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.fileList = [{
        uid: '-xxx',
        percent: 100,
        name: file.name,
        status: 'error',
      }];
      //this.msg.error(`${file.name} file upload failed.`);
    }
  }
  beforeUpload = (file: MwcUploadFile): boolean => {
    file.status = 'uploading';
    file.percent = 50;
    this.fileList = [];
    this.fileList.push(file);
    this.fileList = [...this.fileList];
    let uploadedFile: any = file;
    const reader = new FileReader();

    reader.onload = () => {
      // This is where the content of the file will be available.
      this.uploadFile(file);
    };

    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };

    // Read the file as text
    reader.readAsText(uploadedFile);
    return false;
  }
  formDataForFile = new FormData();

  hasValidExtension(fileName: string, allowedExtensions: string[]): boolean {
    const regex = new RegExp(`\\.(${allowedExtensions.join('|')})$`, 'i');
    return regex.test(fileName);
  }


  uploadFile(file: any) {
    this.showUpload();
    let fr = new FileReader();


    if (this.fileList && this.fileList[0] && this.fileList.length > 0) {

      const allowedExtensions = ['pdf', 'doc', 'docx', 'txt', 'html', 'htm'];
      if (!this.hasValidExtension(this.fileList[0].name, allowedExtensions)) {
        this.fileList = [];
        this.errorMessage = "Invalid supported file, Only doc, docx, txt, html, htm and pdf file allowed.";
        this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'top', mwcClass: 'error-notification-content' });
        this.cdRef.detectChanges();
        return;
      }
      const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
      var fileSize = this.fileList[0].size;
      if (fileSize > MAX_FILE_SIZE) {
        this.fileList = [];
        this.errorMessage = "File size exceeds the 10MB limit. Please upload a smaller file.";
        this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'top', mwcClass: 'error-notification-content' });
        this.cdRef.detectChanges();
        return;
      }

      this.formDataForFile.set('file', this.fileList[0], this.fileList[0].name);
    }


    const totalDuration = 2000; // 2 seconds
    const steps = 20; // Number of updates (can be increased for smoother animation)
    const stepTime = totalDuration / steps; // Time for each step (milliseconds)
    this.contentAnalysisStatus = 'analyzing';
    interval(stepTime)
      .pipe(take(steps + 1)) // Run the interval 20 times (0% to 100%)
      .subscribe((step) => {
        const percentDone = Math.min((step / steps) * 100, 100); // Calculate progress
        if (percentDone == 100) {
          this.contentAnalysisStatus = '';
        }
        if (this.fileList.length > 0) {
          this.fileList[0].percent = Math.round(percentDone);
          this.fileList[0].status = percentDone === 100 ? 'done' : 'uploading';
          this.fileList = [...this.fileList]; // Trigger change detection
          this.cdRef.detectChanges();
        }
      });
  }

  tryAgain() {
    this.generateAiForm.controls['contextUrl'].setValue('');
    this.clearContextText();
    this.isUploadVisible = true;
    this.isUrlVisible = true;
    this.fileList = []
    this.contentAnalysisStatus = "";
    this.contentAnalysis = false;
    this.cdRef.detectChanges();
  }
  fileContentForContentRevamp: string = "";
  errorMessage: string;

  analyzeandProceed() {
    this.contentAnalysisStatus = 'analyzing';
    this.contentAnalysis = true;
    var request = new ContextAnalysisDetails()
    request.url = this.generateAiForm.controls["contextUrl"].value;
    this.formDataForFile.set("url", request.url);
    request.text = this.generateAiForm.controls["contextText"].value ?? "";
    this.formDataForFile.set("text", request.text);
    if (this.youtubeSummaryContent) {
      this.formDataForFile.set("youtubeSummary", "true");
    }
    if (request.url == "" && !this.hasContextText) {
      this.isFileAnalysis = true;
    } else {
      this.isFileAnalysis = false;
    }
    if (this.bulkMetaGeneration) {
      this.bulkUploadAnalysis = true;
      this.bulkUploadAnalysisStatus = 'analyzing';
      this.selectedIndex = 1;
    }
    this.cdRef.detectChanges();

    const uploadReq = new HttpRequest('POST', this.baseUrl + 'api/Article/UploadContextAnalysisDetailsForContentRecreate', this.formDataForFile, { reportProgress: true, headers: new HttpHeaders({ 'ngsw-bypass': '' }).append('Content-Disposition', 'multipart/form-data') });

    this.uploadFileSubscription = this.http.request<any>(uploadReq).subscribe((event) => {

      if (event.type === HttpEventType.UploadProgress) {
      } else if (event.type === HttpEventType.Response) {
        if (!event.body.success) {
          this.contentAnalysisStatus = 'error';
          this.fileList = [];
          this.errorMessage = event.body.message;
          this.notification.template(this.ErrorAlertTemplate, { mwcDuration: 3000, mwcStyle: { padding: '16px' }, mwcPlacement: 'top', mwcClass: 'error-notification-content' });
          this.cdRef.detectChanges();
          return;
        }
        if (request.url == "" && this.fileList.length > 0) {
          this.fileList[0].percent = 100;
          this.fileList[0].status = 'done';
        }
        var res: ContextAnalysisDetailsResponse = event.body;
        this.fileContentForContentRevamp = res.body;
        console.log(res)
        this.contentAnalysisStatus = '';
        if (res.success) {
          this.generateAiForm.patchValue(
            {
              description: res.title
            }
          );
          this.selectedKeywords = res.keywords;
          this.keywordInputVisible = true;
          this.selectedIndex = 1;
          this.isAnalyzeandProceed = false;
        }
        else {
          this.contentAnalysisStatus = 'error';
        }
        this.cdRef.detectChanges();
      }
    }, (error: any) => {
      this.contentAnalysisStatus = 'error';
      this.cdRef.detectChanges();

    });
    //of(this.contentAnalysis).pipe(delay(5000)).subscribe((res) => {
    //  //success case
    //  this.selectedIndex = 1;
    //  this.isAnalyzeandProceed = false;

    //  //error case
    //  // else condition
    //  //this.contentAnalysisStatus = 'error';
    //  this.cdRef.detectChanges();
    //});
  }
  contentAnalysisReset() {
    this.contentAnalysis = false;
    /* this.fileList = [];
    this.contentAnalysisStatus = 'analyzing';
    this.generateAiForm.controls['contextUrl'].setValue(''); */
  }
  showUrl() {
    this.fileList = [];
    this.clearContextText();
    this.isUploadVisible = false;
    this.isUrlVisible = true;
  }
  showUpload() {
    this.generateAiForm.controls['contextUrl'].setValue('');
    this.clearContextText();
    this.isUploadVisible = true;
    this.isUrlVisible = false;
  }
  // The FAQ template picks its source from tabs rather than the OR-separated stack, so the tabs decide
  // which input is on screen. Every other template keeps the isUrlVisible / isUploadVisible toggles.
  contextSourceTab: string = 'url';

  get showUrlInput(): boolean {
    return this.generateFaqsFromExistingContent ? this.contextSourceTab == 'url' : this.isUrlVisible;
  }
  get showUploadInput(): boolean {
    return this.generateFaqsFromExistingContent ? this.contextSourceTab == 'upload' : this.isUploadVisible;
  }
  get showTextInput(): boolean {
    return this.generateFaqsFromExistingContent && this.contextSourceTab == 'text';
  }
  // Switching tab is what enforces one source per analysis - the inputs left behind are cleared.
  contextSourceTabChange(tab: string) {
    this.fileList = [];
    this.formDataForFile.delete('file');
    this.generateAiForm.controls['contextUrl'].setValue('');
    this.clearContextText();
    this.cdRef.detectChanges();
  }
  get hasContextText(): boolean {
    return !!this.generateAiForm?.controls['contextText']?.value?.trim();
  }

  readonly contextTextMaxWords = 5000;
  contextTextWordCount = 0;

  // Counted on input rather than in a getter: a paste can run to tens of thousands of characters and a
  // getter would re-scan the whole string on every change detection pass.
  onContextTextChange() {
    const value: string = this.generateAiForm.controls['contextText'].value ?? "";
    const words = value.match(/\S+/g);
    this.contextTextWordCount = words ? words.length : 0;
    this.cdRef.detectChanges();
  }

  // Over the limit the text is left alone but cannot be submitted - same treatment as the meta title
  // field, which turns its line red rather than truncating what the user typed.
  get isContextTextOverLimit(): boolean {
    return this.contextTextWordCount > this.contextTextMaxWords;
  }

  // Clearing the box has to reset the counter with it, so every caller goes through here.
  private clearContextText() {
    this.generateAiForm.controls['contextText'].setValue('');
    this.contextTextWordCount = 0;
  }
  parentUrlChange() {
    this.generateAiForm.controls['individualUrls'].setValue('');
    this.isIndividualUrlVisible = false;
    this.isParentUrlVisible = true;
  }
  individualUrlsChange() {
    this.generateAiForm.controls['websiteParentUrl'].setValue('');
    const control = this.generateAiForm.get('individualUrls');
    control?.updateValueAndValidity();
    this.isIndividualUrlVisible = true;
    this.isParentUrlVisible = false;
  }
  selectTemplateAndGenerate() {
    // By default Blog Post is the template
    var blog = this.rowedData
      .map(innerArray =>
        innerArray.filter(obj => obj.isSelected === true)
      )
      .filter(innerArray => innerArray.length > 0);

    var blogTemplate = new Template();
    if (blog && blog.length > 0) {
      blogTemplate = blog[0][0];
    }
    this.generateArticle(false, blogTemplate)
    //this.selectedIndex = 6;
    //this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
    const commonTabs = [
      { index: 1, name: 'Topic Details', iconName: 'file-05', selected: false },
      { index: 2, name: 'Content Brief', iconName: 'file-plus-02', selected: false },
      { index: 3, name: 'Preferences', iconName: 'settings-04', selected: false },
    ];
    // Content Outline is only offered for the templates a heading structure is meaningful for.
    if (this.isContentOutlineAvailable) {
      commonTabs.push({ index: 4, name: 'Content Outline', iconName: 'file-check-02', selected: false });
    }

    if (this.customTemplates) {
      this.isUploadVisible = false;
    }
    if (this.refreshExistingContent) {
      this.tabs = [
        { index: 0, name: 'Analysis', iconName: 'file-search-03', selected: false },
        ...commonTabs,
        { index: 5, name: 'Select Template', iconName: 'cursor-box', selected: false }
      ];
      this.isAnalyzeandProceed = true;
    } else if (this.youtubeSummaryContent) {
      this.tabs = [
        { index: 0, name: 'Analysis', iconName: 'file-search-03', selected: false },
        ...commonTabs
      ];
      this.isUploadVisible = false;
      this.isAnalyzeandProceed = true;
    } else if (this.generateFaqsFromExistingContent) {
      this.tabs = [
        { index: 0, name: 'Analysis', iconName: 'file-search-03', selected: false },
        ...commonTabs
      ];
      this.isAnalyzeandProceed = true;
    } else if (this.customTemplates) {
      this.tabs = [
        { index: 0, name: 'Creation Flow', iconName: 'file-search-03', selected: false },
        ...commonTabs
      ];
      this.isAnalyzeandProceed = true;
    } else if (this.bulkMetaGeneration) {
      this.tabs = [
        { index: 0, name: 'Upload URLs', iconName: 'globe-01', selected: false },
        /*{ index: 1, name: 'Instructions', iconName: 'file-question-02', selected: false },*/
        { index: 1, name: 'Brand Voice', iconName: 'clipboard-report', selected: false },
        { index: 2, name: 'Target Audience', iconName: 'users-03', selected: false }
      ];
      this.isAnalyzeandProceed = false;
    } else {
      this.tabs = commonTabs.map(tab => ({
        ...tab,
        index: tab.index - 1
      }));
      this.isAnalyzeandProceed = false;
    }

    this.showSelectTemplatesTab = this.isRegenerateFlow && !this.refreshExistingContent && !this.bulkMetaGeneration;
    if (this.showSelectTemplatesTab) {
      this.tabs = [
        ...this.tabs,
        { index: this.tabs.length, name: 'Select Templates', iconName: 'cursor-box', selected: false }
      ];
    }

    // tab.index is compared against selectedIndex, which the tabset drives by position, so the
    // indexes have to match the final positions. Content Outline is not always in the list, which
    // would otherwise leave the tabs the branches above number by hand off by one.
    this.tabs = this.tabs.map((tab, position) => ({ ...tab, index: position }));

    if (this.mwcModalData.isRegenerateFlow) {
      if (this.mwcModalData.AIData.templateTitle == "FAQs") {
        this.selectedIndex += 1;
      }
    }
   if (this.selectedTemplateTitle == 'Marketing Brief') {
      this.generateQuestionFromAI();
    }
    this.cdRef.detectChanges();
  }

  selectedGoalDetail: Goal = this.goalsList.find(g => g.isSelectedGoal);

  SelectedGoal(value) {
    this.goalsList.forEach((goal) => {
      goal.isSelectedGoal = false;
      if (goal.title == value) {
        goal.isSelectedGoal = true;
      }
    });
    const selectedGoal = this.goalsList.find(x => x.isSelectedGoal);
    this.selectedGoalDetail = selectedGoal;
    this.cdRef.detectChanges();
  }


  multiUrlValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const urls = control.value
      .split(/[\n,]+/)
      .map(u => u.trim())
      .filter(Boolean);
    if (urls.length > 300) {
      return { maxUrlsExceeded: true };
    }  
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/\S*)?$/;
    const allValid = urls.every(url => urlPattern.test(url));
    if (!allValid) return { invalidUrl: true };
    try {
      const firstDomain = new URL(urls[0]).hostname.toLowerCase();
      const allSameDomain = urls.every(url => {
        return new URL(url).hostname.toLowerCase() === firstDomain;
      });
      if (!allSameDomain) {
        return { multipleDomainsNotAllowed: true };
      }
    } catch {
      return { invalidUrl: true }; // In case URL parsing fails
    }
    return null;
  }

  maxWordsValidator(maxWords: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const wordCount = this.getWordCount(control.value);
      return wordCount > maxWords ? { maxWordsExceeded: { maxWords, actual: wordCount } } : null;
    };
  }

  getWordCount(value: string): number {
    const trimmed = (value || '').toString().trim();
    return trimmed ? trimmed.split(/\s+/).length : 0;
  }


  get selectedLanguageLabel(): string {
    return this.provinceData.find(p => p.value == this.selectedValueLanguage)?.label ?? '';
  }

  get hasDescription() {
    return (this.generateAiForm.controls['description'].value?.length ?? 0) > 0;
  }

  get hasInstructions() {
    return (this.generateAiForm.controls['instructions'].value?.length ?? 0) > 0;
  }
  
  get isGenerateDisabled(): boolean {
    if (this.bulkMetaGeneration) {
      return false;
    }
    return !this.hasDescription;
  }

  // Regenerate needs at least one template to generate an article from. Only applies on the Select
  // Templates step, where the button generates instead of moving to the next step.
  get isRegenerateDisabled(): boolean {
    return this.showSelectTemplatesTab
      && this.selectedIndex == (this.tabs.length - 1)
      && !this.templatesList.some(t => t.selected);
  }
  onVisibilityToggle(value: any): void {    
    this.isKnowledgeVaultEnable = value;   
  }

  onVisibilityToggleIL(value: any): void {
    this.isInternalLinksEnable = value;
  }

  callParallelChunks(
    pillarIdea: string,
    coreTopic: string,
    callback: (result: string | null) => void
  ): void {
    this.isLoading = true;

    forkJoin({
      responseBasedOnPillarIdea: this.getChunksInfoObservable(pillarIdea),
      responseBasedOnCoretopic: this.getChunksInfoObservable(coreTopic)
    }).pipe(
      finalize(() => {
        this.isLoading = false;
        this.cdRef.detectChanges();
      })
    ).subscribe({
      next: ({ responseBasedOnPillarIdea, responseBasedOnCoretopic }) => {

        const pillarSummary = responseBasedOnPillarIdea.generativeSummary?.trim() || "";
        const coreSummary = responseBasedOnCoretopic.generativeSummary?.trim() || "";

        const isValid = (text: string) =>
          text && !text.toLowerCase().includes("does not contain information");

        const validSummaries: string[] = [];

        if (isValid(pillarSummary)) validSummaries.push(pillarSummary);
        if (isValid(coreSummary)) validSummaries.push(coreSummary);

        const result =
          validSummaries.length > 0 ? validSummaries.join("\n\n") : null;

        callback(result); // ✅ RETURN HERE
      },
      error: (error) => {
        console.error('Error:', error);
        this.notification.snackbarWarning('Something went wrong.');
        callback(null);
      }
    });
  }

  getChunksInfoObservable(textQuery: string): Observable<GenerativeSearchResponse> {
    const request: GetTenantIDRequest = {
      business_id: this._storageHelper.user.bId,
      profile_id: this._storageHelper.user.pId.toString(),
      agency_id: '1'
    };

    return this.abpService.getTenantID(request).pipe(
      switchMap((tenantResponse: GetTenantIDResponse) => {

        if (!tenantResponse?.tenant_id) {
          throw new Error('Invalid tenant ID');
        }

        //const searchRequest: SemanticSearchRequest = {
        //  textQuery: textQuery,
        //  tenantId: tenantResponse.tenant_id,
        //  limit: 10,
        //  offset: 0,
        //  scoreThreshold: 0.5
        //};

        //return this.SemanticSearch(searchRequest);

        const searchRequest: SemanticSearchRequestV2 = {
          textQuery: textQuery,
          tenantId: tenantResponse.tenant_id,
          limit: 10,
          offset: 0
        };

        return this.SemanticSearchV2(searchRequest);

      })
    );
  }

  getChunksInfo(textQuery: string, callback: (result: string | null) => void): void {
    this.isLoading = true;

    const request: GetTenantIDRequest = {
      business_id: this._storageHelper.user.bId,
      profile_id: this._storageHelper.user.pId.toString(),
      agency_id: '1'
    };

    this.abpService.getTenantID(request).pipe(
      switchMap((tenantResponse: GetTenantIDResponse) => {

        if (!tenantResponse?.tenant_id) {
          throw new Error('Invalid tenant ID');
        }

        const searchRequest: SemanticSearchRequestV2 = {
          textQuery,
          tenantId: tenantResponse.tenant_id,
          limit: 10,
          offset: 0
        };

        return this.SemanticSearchV2(searchRequest);
      }),
      finalize(() => {
        this.isLoading = false;
        this.cdRef.detectChanges();
      })
    ).subscribe({
      next: (searchResponse) => {
        const summary = searchResponse.generativeSummary?.toLowerCase() || "";

        if (summary && !summary.includes("does not contain information")) {
          callback(searchResponse.generativeSummary);
        } else {
          callback(null);
        }
      },
      error: () => {
        this.notification.snackbarWarning('Something went wrong.');
        callback(null);
      }
    });
  }

  SemanticSearch(searchRequest: SemanticSearchRequest): Observable<SearchResponse> {
    return this.intelligentSearchService.SemanticSearch(searchRequest);
  }

  SemanticSearchV2(searchRequest: SemanticSearchRequestV2): Observable<GenerativeSearchResponse> {
    return this.intelligentSearchService.SemanticSearchV2(searchRequest).pipe(
      map((response: SearchResponseV2) => {
        const chunkText = (response.results || [])
          .map((result: any) => result?.chunk_text)
          .filter((text: string) => !!text)
          .join('\n\n');

        return {
          queryText: response.queryText,
          generativeSummary: chunkText,
          sourceDocuments: [],
          modelName: '',
          offset: response.offset,
          timeTakenMs: response.timeTakenMs
        } as GenerativeSearchResponse;
      })
    );
  }

  HybridSearch(searchRequest: HybridSearchRequest): Observable<SearchResponse> {
    return this.intelligentSearchService.HybridSearch(searchRequest);
  }
}
